import React, { useState, useEffect, useRef } from "react";
import { APPROVER_TYPES, FRISCO_NEGATIVE_STATUS, FRISCO_POSITIVE_STATUS, FRISCO_TABLE_STATUS, glossary, PROCESS_KEYS, UPLOADER_TYPES } from "./Constants";
import { setCurrentAppId, setTemplateId } from "../../store/userAuthSlice";
import SideNav from "./SideNav";
import {
  AppLayout,
  Button,
  ColumnLayout,
  Input,
  Icon,
  Textarea,
  Container,
  Header,
  Box,
  Grid,
  SpaceBetween,
  Link,
  ExpandableSection,
  ContentLayout,
  Table,
  Modal,
  Spinner,
  RadioGroup,
  FileUpload,
  HelpPanel,
  Flashbar,
  Alert,
  Checkbox,
  Popover
} from "@amzn/awsui-components-react";

import { CodeView } from '@amzn/awsui-code-view';
import rubyHighlight from "@amzn/awsui-code-view/highlight/ruby";


import "../../index.scss";
import "./styles.scss"
import { useSelector, useDispatch } from "react-redux";
import { canAddEditDeleteApplication } from "../Templates/Utils/Permissions";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';

import * as XLSX from 'xlsx';

import CustomInput from "../Templates/components/CustomInput";
import CustomSelect from "../Templates/components/CustomSelect";
import CustomMultiSelect from "../Templates/components/CustomMultiSelect";
import CustomCheckbox from "../Templates/components/CustomCheckbox";
import CustomMultiHybridInputAndSelect from "../Templates/components/CustomMultiHybridInputAndSelect";
import CustomProcessSchemaInput from "../Templates/components/CustomProcessSchemaInput";
import { getEditableFields } from "../Templates/Utils/FormMetadata";
import { createProcess, getProcessById, updateProcess, getAppPromise, deleteProcess, getNormalisedColumnName, createAuditLog, getCurrentTime, getNotification, updateAliasToCurrentState, updateAliasToCurrentStateMultiple, auditSOXFRISCO } from "src/Ateam-BI/Templates/Utils/AppActivityUtilsAppsyncPlus"
import { useSuggestedLogins } from "src/hooks/useSuggestedLogins";
import { TEMPLATE_APP, APPS_WITH_APP_LEVEL_PERMISSIONS_IN_TEMPLATE } from "../Templates/Constants";
import { STEP_FUNCTION_CONFIG, GLUE_JOB_CONFIG } from 'src/constants/AppConstants';
import Feedback from "src/generic-components/UserFeedback/Feedback";
import { configureFriscoS3 } from "src/context/AuthContextUtility";
import { formActionableNotificationItems, formNotificationItems } from "./NotificationUtilities";
import TANCManager from "../TANC/TANCManager";
import { disableTANC, enableTANC, reloadTANCConfigurationForFRISCO, tancAssociationStatus } from "src/utilities/AppSyncPlusAPIs";
import { convertEpochToPST } from "./FilterUtilities";
import appSettings from "../CorpReporting/app_settings";
import { getProcessNameMaxLength } from "src/plugins/CorpReportingViewOptions";
import useVisibleTimeTracker from 'src/katalMetrics/useVisibleTimeTracker';
import { ACTION_METHODS, METRIC_TYPE, SITE_SERVICES } from 'src/katalMetrics/metricsModels';
import { createKatalTimerStopWatch, stopAndCaptureTimeMetricsWithBasicAttributes} from "src/katalMetrics/metricsHelperMethods"
import { getCustomAttribute as getCustomAttributeUtil, updateCustomAttribute as updateCustomAttributeUtil, getCustomAttributeValue as getCustomAttributeValueUtil } from "../utils/customAttributeUtils";
import CleanupDataModal from "./CleanupDataModal/CleanupDataModal";

export default (props) => {
  const dispatch = useDispatch();
  const currentStage = useSelector((globalState) => globalState.auth.currentStage)
  const currentAppId = useSelector((globalState)=>globalState.auth.currentAppId)
  const templateId = useSelector((globalState) => globalState.auth.templateId)
  const history = useHistory();
  const [NavOpen, setNavOpen] = useState(true);
  const [showLoadingIcon, setShowLoadingIcon] = useState(true);
  const userId = useSelector((globalState) => globalState.auth.userId);
  let { id: paramId } = useParams();
  let { pid: paramPid } = useParams();
  
  const id = props.id || paramId;
  const pid = props.pid || paramPid;
  const [isNewProcess, setIsNewProcess] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [errorMessage, setErrorMessage] = useState('')
  const [alertErrorMessage, setAlertErrorMessage] = useState(null)
  const [accessPerms, setAccessPerms] = useState(props.accessPerms);
  const [canDelete, setCanDelete] = useState(false)
  const [canEdit, setCanEdit] = useState(false)
  const [canAdd, setCanAdd] = useState(false)
  const [enableEditAction, setEnableEditAction] = useState(false)
  const [processData, setProcessData] = useState({})
  const [processDataEdited, setProcessDataEdited] = useState({})
  const [fieldMetadata, setFieldMetadata] = useState({});
  const [sampleFile, setSampleFile] = useState([]);
  const [generatingSchemaLoader, setGeneratingSchemaLoader] = useState(false);
  const [deleteConfirmationModal, setDeleteConfirmationModal] = useState(false);
  const [deleteNotificationModal, setDeleteNotificationModal] = useState(false);
  const [updateNotificationModal, setUpdateNotificationModal] = useState(false);
  const [deleteAppName, setDeleteAppName] = useState('');
  const [flashBarComments, setFlashBarComments] = useState();
  const [schemaFileUrl, setSchemaFileUrl] = useState();
  const [isApprovalDisabled, setIsApprovalDisabled] = useState(false);
  const [backUrl, setBackUrl] = useState(null)
  const [updateComments, setUpdateComments] = useState("")
  const [modalError, setModalError] = useState("")
  const [toolsOpen, setToolsOpen] = useState(false);
  const [selectedDelsertKeys, setSelectedDelsertKeys] = useState([]);
  const [delsertDeleteScript, setDelsertDeleteScript] = useState([])
  const [delsertInsertScript, setDelsertInsertScript] = useState([])
  const [deleteDataOnUpdate, setDeleteDataOnUpdate] = useState(false)
  const [delsertSubmitPopupVisible, setDelsertSubmitPopupVisible] = useState(false)
  const [schemaStatus, setSchemaStatus] = useState(false)
  const [delsertPopupCalledFrom, setDelsertPopupCalledFrom] = useState ()
  const [dataGenerationPlatform, setDataGenerationPlatform] = useState('')
  const [dataSharePlatform, setDataSharePlatform] = useState('')
  const [dataGenerationPlatformClass, setDataGenerationPlatformClass] = useState('')
  const [dataSharePlatformClass, setDataSharePlatformClass] = useState('')
  const [isBackupWorkdocsEnabled, setIsBackupWorkdocsEnabled] = useState(false) 
  const [isQueuedExecution, setIsQueuedExecution] = useState(false) 
  const [backupOnlyToAliasRef, setBackupOnlyToAliasRef] = useState(false) 
  const [notificationBarItems, setNotificationBarItems] = useState([])
  const [actionableNotificationItems,setActionableNotificationItems] = useState([])
  const [selectedActionableNotificationItems,setSelectedActionableNotificationItems] = useState([])
  const { suggestedLogins, aliasesLoading, getSuggestedLoginsCaller } = useSuggestedLogins();
  const [isActionOnNotificationPending, setIsActionOnNotificationPending] = useState(false)
  const [tancEnabled, setTancEnabled] = useState(false)
  const [tancEnabledExistingStatus, setTancEnabledExistingStatus] = useState(false)
  const [showTancPermissionModal, setShowTancPermissionModal] = useState(false)
  const [tancInfo, setTancInfo] = useState(null)
  const [isCleanupDataModalVisible, setCleanupDataModalVisible] = useState(false);
  const [friscoTempId, setFriscoTempId] = useState(pid? `TEMP_FRISCO_${pid}` : `TEMP_FRISCO_${uuidv4()}`)
  const tancManagerRef = useRef();
  const ln = useLocation()
  useVisibleTimeTracker([{
          metricName : 'actionPerformedBy',
          metricValue : userId,
          metricType : METRIC_TYPE.STRING,
          isMonitor : true
      },
      {
          metricName : 'pagePath',
          metricValue : `${ln.pathname}`,
          metricType : METRIC_TYPE.STRING,
          isMonitor : true
      }
    ], "timeSpent", ACTION_METHODS.TIME_SPENT_ON_PAGE, SITE_SERVICES.FRISCO);

  useEffect(() => {
    configureFriscoS3()
    setInitView()
    setBackUrl(getParam('back'))
    return () => {
      // this now gets called when the component unmounts
    };
  }, []);

  useEffect(() => {

    if (processDataEdited.hasOwnProperty(PROCESS_KEYS.action) && processDataEdited[PROCESS_KEYS.action] === 'DELSERT') {

      if(selectedDelsertKeys?.length > 0 && processDataEdited[PROCESS_KEYS.schema] && 
        processDataEdited[PROCESS_KEYS.team] && processDataEdited[PROCESS_KEYS.business] &&
        processDataEdited[PROCESS_KEYS.dataset_name]) {
         // Generate New Script 
      
      const tableName = `${processDataEdited[PROCESS_KEYS.team]}_${processDataEdited[PROCESS_KEYS.business]}_${processDataEdited[PROCESS_KEYS.dataset_name]}`.toLowerCase()
      setDelsertDeleteScript(generateDelsertDeleteScript(selectedDelsertKeys, tableName))
      setDelsertInsertScript(generateDelsertInsertScript(processDataEdited[PROCESS_KEYS.schema].map((item) => item.column_name), tableName))
      } else {
        //Reset Script
        setDelsertDeleteScript([])
        setDelsertInsertScript([])
      }
      
    }

  },[selectedDelsertKeys,processDataEdited])

  useEffect(() => {
    if (processDataEdited.hasOwnProperty(PROCESS_KEYS.critical_data) && processDataEdited.hasOwnProperty(PROCESS_KEYS.sox_approved)) {
    
      if(processDataEdited[PROCESS_KEYS.critical_data] && processDataEdited[PROCESS_KEYS.sox_approved]) {
        setDataGenerationPlatform("Red")
        setDataSharePlatform("None")
        setDataGenerationPlatformClass("red_badge")
        setDataSharePlatformClass("grey_badge")
      } else if (!processDataEdited[PROCESS_KEYS.critical_data] && processDataEdited[PROCESS_KEYS.sox_approved]) {
        setDataGenerationPlatform("Red")
        setDataSharePlatform("Orange")
        setDataGenerationPlatformClass("red_badge")
        setDataSharePlatformClass("orange_badge")
      } else if (!processDataEdited[PROCESS_KEYS.critical_data] && !processDataEdited[PROCESS_KEYS.sox_approved]) {
        setDataGenerationPlatform("Orange")
        setDataSharePlatform("Red")
        setDataGenerationPlatformClass("orange_badge")
        setDataSharePlatformClass("red_badge")
      } else if (processDataEdited[PROCESS_KEYS.critical_data] && !processDataEdited[PROCESS_KEYS.sox_approved]) {
        setDataGenerationPlatform("Red")
        setDataSharePlatform("None")
        setDataGenerationPlatformClass("red_badge")
        setDataSharePlatformClass("grey_badge")
      }

    }

    if (processDataEdited.hasOwnProperty(PROCESS_KEYS.custom_attributes)){
      //BACKUP_WORKDOCS_LOCATION_ENABLED
      let attr = getCustomAttribute('BACKUP_WORKDOCS_LOCATION_ENABLED', 'FRISCO')
      setIsBackupWorkdocsEnabled(attr[0] == 'true')

      let attrbackup_to_aliases = getCustomAttribute('UPLOAD_ONLY_TO_ALIASES', 'FRISCO')
      setBackupOnlyToAliasRef(attrbackup_to_aliases[0] == 'true')

      let attr_queue = getCustomAttribute('QUEUED_EXECUTION', 'FRISCO')
      setIsQueuedExecution(attr_queue[0] == 'true')
    }
  },[processDataEdited])

  useEffect(() => {
    setProcessDataEdited(processData)
    if (processData.hasOwnProperty(PROCESS_KEYS.status)
      && processData[PROCESS_KEYS.status]
      && processData[PROCESS_KEYS.status].toLowerCase().includes("failed")) {
      setFlashBarComments([{
        type: "error",
        dismissible: true,
        dismissLabel: "Dismiss message",
        onDismiss: () => setFlashBarComments([]),
        content: (
          <>
            {processData[PROCESS_KEYS.status]}
          </>
        ),
        id: "comments"
      }])
    }

    if (processData.hasOwnProperty(PROCESS_KEYS.action) &&  processData[PROCESS_KEYS.action] === 'DELSERT') {

      const delsertKeys = processData[PROCESS_KEYS.schema].filter((item) => item['delsert_key']).map((i) => i['column_name'])
      setSelectedDelsertKeys(delsertKeys)
    }

    if (FRISCO_POSITIVE_STATUS.includes(processData?.status) || FRISCO_NEGATIVE_STATUS.includes(processData?.status)) {
      setSchemaStatus(true)
    } else {
      setSchemaStatus(false)
    }
  }, [processData])

  useEffect(() => {
    if (sampleFile.length > 0) {
      suggestSchema()
    }
  }, [sampleFile])

  useEffect(() => {
    if (tancInfo?.tanc_id != null && tancInfo?.association_id == pid
      && tancInfo?.association_id_type == 'FRISCO') {
      setTancEnabledExistingStatus(tancInfo?.status)
      setTancEnabled(tancInfo?.status)
    } else {
      setTancEnabledExistingStatus(false)
      setTancEnabled(false)
    }
  }, [tancInfo])
  

  useEffect(() => {
    checkIfFormIsSubmittable()
  }, [processDataEdited, canEdit])

  const dismissDeleteDialog = () => {
    setDeleteAppName('')
    setDeleteConfirmationModal(false)
  }

  const dismissDeleteNotifyDialog = () => {
    setDeleteNotificationModal(false)
    if(backUrl){
      history.push(`/${backUrl}`)
    }else{
      history.push(`/App/${id}`)
    }
    

  }

  const dismissUpdateNotifyDialog = () => {
    setUpdateNotificationModal(false)
  }

  const getCustomAttribute = (attribute_type, sub_type) => {
    return getCustomAttributeUtil(
      processDataEdited,
      attribute_type,
      sub_type,
      PROCESS_KEYS.custom_attributes,
      PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS
    );
  }

  const generateDelsertDeleteScript = (delsertKeys, tableName) => {

    const deleteScript = []
    deleteScript.push(`-- delete statement: \n`)
    deleteScript.push(`DELETE FROM frisco.${tableName}`)
    deleteScript.push(`USING frisco_stg.${tableName} stg`)
    deleteScript.push(`WHERE`)

    delsertKeys.forEach((key, index) => {
      (index === delsertKeys.length - 1 ? deleteScript.push(`${tableName}.${key} = stg.${key};`) : deleteScript.push(`${tableName}.${key} = stg.${key} AND`))
    })
    return deleteScript;
  }
  
  const generateDelsertInsertScript = (columns, tableName) => {
    const insertScript = []
    insertScript.push(`-- insert statement: \n`)
    insertScript.push(`INSERT INTO frisco.${tableName} (`)
    columns.forEach((column, index) => {
      (index === columns.length - 1 ? insertScript.push(`${column})`) : insertScript.push(`${column},`))
    })
    insertScript.push(`SELECT`)
    columns.forEach((column, index) => {
      (index === columns.length - 1 ? insertScript.push(`${column}`) : insertScript.push(`${column},`))
    })
    insertScript.push(`FROM frisco_stg.${tableName};`)
    return insertScript;
  }

  const suggestSchema = async () => {
    setGeneratingSchemaLoader(true)
    let file = sampleFile[0]
    let data = await file.arrayBuffer();
    const wb = XLSX.readFile(data, { sheetRows: 1 })
    const workbook = XLSX.read(data)
    const worksheet = workbook.Sheets[workbook.SheetNames[0]]
    var readOptions = { type: 'binary', raw: false, defval: null, cellNF: false, cellDates: true, cellText: false }
    const jsonData = XLSX.utils.sheet_to_json(worksheet, readOptions)
    const headerInfo = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: "", raw: false, cellDates: true})

    const colNames = headerInfo[0]
    if(colNames.length > 1600){
      setErrorMessage("Max columns allowed is 1600. The file exceeds the allowed column length")
    }
    // create schema
    let schemas = []
    colNames.forEach((col, index) => {
      schemas.push({
        column_name: getNormalisedColumnName(col),
        data_type: getDataTypeForColumn(index, headerInfo),
        mandatory: true,
        delsert_key: false,
        non_empty_column: false,
        comparison_operator: '',
        comparison_value: ''
      })
    })

    processDataEdited[PROCESS_KEYS.schema] = schemas
    setProcessDataEdited({ ...processDataEdited })
    setGeneratingSchemaLoader(false)
  }

  const increaseCount = (key, incVal, annotation) => {
    if (!annotation.hasOwnProperty(key)) {
      annotation[key] = 0
    }
    annotation[key] = annotation[key] + incVal
  }

  const getDataTypeForColumn = (index, headerInfo, defVal = 'VARCHAR') => {
    let annotation = {}
    let iter_length = headerInfo.length % 100;
    for (let i = 1; i < iter_length; i++) {
      let row = headerInfo[i]
      let boolArray = ["true", "false", "t", "f","yes","no"]
      if(row[index] == null 
        || row[index] == undefined 
        || row[index].toString().length <= 0){
        continue
      }
      if(boolArray.indexOf(row[index].toString().toLowerCase()) >=0 ){
        increaseCount('BOOLEAN', 1, annotation)
      }else if (!isNaN(Number(row[index]))) {
        if (Number(row[index]) % 1 == 0 && Number(row[index])<2147483647) {
          // priority to decimal
          increaseCount('INTEGER', 1, annotation)
        } else {
          increaseCount('DECIMAL', 999, annotation)
        }
      } else if (!isNaN(new Date(row[index]))) {
        let dateSplit = row[index].split('T')
        // priority to TIMESTAMP
        if (dateSplit.length > 1 && dateSplit[1] != '') {
          increaseCount('TIMESTAMP', 1, annotation)
        } else {
          increaseCount('DATE', 1, annotation)
        }
      } else {
        increaseCount('VARCHAR', 1, annotation)
      }
    }
    let max = { value: 0, key: defVal }
    Object.keys(annotation).forEach((key) => {
      if (annotation[key] > max['value']) {
        max['value'] = annotation[key]
        max['key'] = key
      }
    })

    return max['key']

  }

  const getParam= (key) => {
    const search = props?.location?.search;
    const params = new URLSearchParams(search);
    const value = params.get(key);
    return value;
  }

  const getGroup = () => {
    return getParam('group')
  }
  
  const setInitView = async () => {
    const pageLoadTime = createKatalTimerStopWatch("timeTaken")
    try {

      let group_id = getGroup()
    if(group_id){
      processData[PROCESS_KEYS.group_id] = group_id
    }
    let next_step = getParam('next_step')
    if(next_step){
      processData[PROCESS_KEYS.next_step] = next_step
    }
      processData[PROCESS_KEYS.app_id] = id
      processData[PROCESS_KEYS.approval_required] = false
      processData[PROCESS_KEYS.multipart_allowed] = false
      processData[PROCESS_KEYS.critical_data] = false
      processData[PROCESS_KEYS.sox_approved] = false
      
      // Initialize custom_attributes with default notification preference (all notifications enabled)
      if (!processData[PROCESS_KEYS.custom_attributes]) {
        processData[PROCESS_KEYS.custom_attributes] = []
        // Set default notification preference to DEFAULT (all notifications enabled)
        processData[PROCESS_KEYS.custom_attributes].push({
          attribute_type: 'NOTIFICATION_PREFERENCE',
          attribute: 'DEFAULT',
          sub_type: 'FRISCO'
        })
      }

      // processData[PROCESS_KEYS.environment] = "Transfer_FAST_RedShift"
      const loadDataPromise = pid
        ? (async () => {
            dispatch(setCurrentAppId(id));
            await loadData();
            setIsEditMode(false)
            setIsNewProcess(false)
          })()
        : Promise.resolve((() => {
            setIsNewProcess(true)
            setShowLoadingIcon(false);
            if (!isEditMode) setIsEditMode(true)
          })())

      const permsPromise = (async () => {
        let appTemplateID = templateId
        if (!templateId) {
          const result = await getAppPromise(id)
          setTemplateId(result.data.getAppsV2[0][TEMPLATE_APP.TEMPLATE_ID])
          appTemplateID = result.data.getAppsV2[0][TEMPLATE_APP.TEMPLATE_ID]
        }
        const accessPerms = await canAddEditDeleteApplication(
          userId,
          id && APPS_WITH_APP_LEVEL_PERMISSIONS_IN_TEMPLATE[currentStage?.toUpperCase()].includes(id) ? id : appTemplateID,
          currentStage
        )
        setCanDelete(accessPerms?.delete)
        setCanEdit(accessPerms?.edit)
        setCanAdd(accessPerms?.add)
        return accessPerms
      })()

      await loadEditableFields()
      const [, accessPerms] = await Promise.all([loadDataPromise, permsPromise])

      // !pid means isNewProcess=true. Sometimes the useeffect take time, so relying on pid. pid is a path param
      if(!pid && !accessPerms?.add){
        setAlertErrorMessage(
          {
            "header":"Access denied",
            "message": "No access to add a new process"
          }
        )
      }else{
        setAlertErrorMessage(null)
      }
    } finally {
      if(!pageLoadTime.isStopped) {
        stopAndCaptureTimeMetricsWithBasicAttributes(pageLoadTime, userId, `${ln.pathname}${location.search}`,ACTION_METHODS.PAGE_LOAD_TIME , SITE_SERVICES.FRISCO)
      }
    }
  }

  const loadData = async () => {
    // setProcessData()
    if (!pid || pid === 'new') {
      setShowLoadingIcon(false);
      return;
    }
    const schemaStatusesForEditEnable = ['Table Schema Updated', 'Table Dropped', 'Table Created', 'Table Creation Failed', 'Table Schema Update Failed', 'Table Drop Failed', 'Data Write to Glue Catalog Failed', 'Data Write to Glue Catalog Complete']
    setIsActionOnNotificationPending(true)

    await Promise.all([
        new Promise((resolve, reject) => {
          getNotification(pid, 'FRISCO_PROCESS', function onSuccess(response){
          formNotificationItems(response, setNotificationBarItems)
          formActionableNotificationItems(response, setActionableNotificationItems)
          setIsActionOnNotificationPending(false)
          resolve();
        }, function onFailure(response){
          setIsActionOnNotificationPending(false)
          reject();
        })
        }),
        new Promise((resolve, reject) => {
            getProcessById(pid, function onSuccess(response) {
          const r = response.data.getProcessByIDV2RDS
          if (r[PROCESS_KEYS.schema] && r[PROCESS_KEYS.schema].length > 0){
            const sorted = r[PROCESS_KEYS.schema].sort((a,b) => a.column_index - b.column_index)
            r[PROCESS_KEYS.schema].forEach((item) => item[PROCESS_KEYS.SCHEMA_KEYS.prev_column_name] = item[PROCESS_KEYS.SCHEMA_KEYS.column_name])
          }
          if (schemaStatusesForEditEnable.includes(r?.status)) {
            setSchemaStatus(true)
          } else {
            setSchemaStatus(false)
          }
          if (r.hasOwnProperty(PROCESS_KEYS.approvers) && r[PROCESS_KEYS.approvers]) {
            r[PROCESS_KEYS.approvers].sort((a,b) => a.column_index - b.column_index)
          }
          setProcessData(r)
          setShowLoadingIcon(false);
          resolve();
        }, function onFailure(response) {
          setShowLoadingIcon(false);
          reject();
        })
            }),
        new Promise((resolve, reject) => {
                tancAssociationStatus(pid, 'FRISCO', function onSuccess(response){
          setTancInfo(response.data.tancAssociationStatus)
          if(tancManagerRef?.current?.props?.tancId){
            tancManagerRef.current.props.tancId = response.data.tancAssociationStatus.tanc_id
          }
          resolve();
        }, function onFailure(response){
          reject();
        })
      })])
    
  }

  const loadEditableFields = async () => {
    let res = await getEditableFields()
    res[PROCESS_KEYS.approvers] = { values: [{ label: "USER", value: APPROVER_TYPES.APPROVER }, { label: "LDAP", value: APPROVER_TYPES.APPROVER_LDAP }] }
    res[PROCESS_KEYS.uploaders] = { values: [{ label: "USER", value: UPLOADER_TYPES.UPLOADER }, { label: "LDAP", value: UPLOADER_TYPES.UPLOADER_LDAP }] }
    res[PROCESS_KEYS.schema] = {
      values: [
        { label: "SMALLINT", value: "SMALLINT" },
        { label: "INTEGER", value: "INTEGER" },
        { label: "BIGINT", value: "BIGINT" },
        { label: "DECIMAL", value: "DECIMAL" },
        { label: "REAL", value: "REAL" },
        { label: "DOUBLE PRECISION", value: "DOUBLE PRECISION" },
        { label: "BOOLEAN", value: "BOOLEAN" },
        { label: "CHAR", value: "CHAR" },
        { label: "VARCHAR", value: "VARCHAR" },
        { label: "DATE", value: "DATE" },
        { label: "TIMESTAMP", value: "TIMESTAMP" },
        { label: "TIMESTAMPTZ", value: "TIMESTAMPTZ" },
        { label: "GEOMETRY", value: "GEOMETRY" },
        { label: "GEOGRAPHY", value: "GEOGRAPHY" },
        { label: "HLLSKETCH", value: "HLLSKETCH" },
        { label: "SUPER", value: "SUPER" },
        { label: "TIME", value: "TIME" },
        { label: "TIMETZ", value: "TIMETZ" },
        { label: "VARBYTE", value: "VARBYTE" }
      ]
    }
    setFieldMetadata(res)
  }

  const getSelectFieldValues = (fieldName, subKey = null) => {
    if (fieldMetadata && fieldMetadata[fieldName] && fieldMetadata[fieldName]['values']) {
      return fieldMetadata[fieldName]['values']
    } else if (subKey && fieldMetadata && fieldMetadata?.[fieldName]?.[subKey] && fieldMetadata?.[fieldName]?.[subKey]?.['values']) {
      return fieldMetadata[fieldName][subKey]['values']
    } else {
      return []
    }
  }

  const updateValueCustomAttributes = (fieldName, value, subKey = null) => {
    updateCustomAttributeUtil(
      processDataEdited,
      fieldName,
      value,
      'FRISCO',
      PROCESS_KEYS.custom_attributes,
      PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS
    );
    setProcessDataEdited(JSON.parse(JSON.stringify(processDataEdited)));
  }

  const updateValue = (fieldName, value, subKey = null) => {
    if (subKey) {
      if (!processDataEdited.hasOwnProperty(fieldName)) {
        processDataEdited[fieldName] = {}
      }
      processDataEdited[fieldName][subKey] = value
    } else {
      processDataEdited[fieldName] = value
    }
    if(fieldName == PROCESS_KEYS.sox_approved) {
      if(value){
        // approval required MUST be true
        setIsApprovalDisabled(true)
        updateValue(PROCESS_KEYS.approval_required, true)
      } else{
        setIsApprovalDisabled(false)
      }   
    }

    if(fieldName === PROCESS_KEYS.action) {
      if(value !== 'DELSERT') {
        const updatedSchema = processDataEdited[PROCESS_KEYS.schema]?.map((item) => {
          const obj = {... item}
          obj['delsert_key'] = false
          return obj
        })
        updateValue(PROCESS_KEYS.schema, updatedSchema)
      }   
    }

    if(fieldName === PROCESS_KEYS.schema) {
      const delsertKeys = value?.filter((item) => item['delsert_key']).map((i) => i['column_name'])
      setSelectedDelsertKeys(delsertKeys)
    }

    setProcessDataEdited(JSON.parse(JSON.stringify(processDataEdited)))
  }

  const getValueCustomAttributes = (fieldName, subKey = null) => {
    return getCustomAttributeValueUtil(
      processDataEdited,
      fieldName,
      'FRISCO',
      PROCESS_KEYS.custom_attributes,
      PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS
    );
  }
  
  const getValue = (fieldName, subKey = null) => {
    if (subKey) {
      if (processDataEdited.hasOwnProperty(fieldName)) {
        return processDataEdited[fieldName][subKey]
      } else {
        return null
      }
    } else {
      return processDataEdited[fieldName]
    }
  }

  const getMultiInputFieldValues = (fieldName) => {
    if (processDataEdited && processDataEdited[fieldName]) {
      return processDataEdited[fieldName]
    } else {
      return []
    }
  }

  const getMultiSelectedOptions = (fieldName) => {
    let arr = processDataEdited[fieldName]
    let selectedOptions = []
    if (arr) {
      arr.forEach((item) => {
        selectedOptions.push({ label: item, value: item })
      })
    }
    return selectedOptions
  }

  const postProcessTeamEmails = (value) => {
    return value.replaceAll("@amazon.com", "")
  }

  const approversValidation = (elements) => {
    let emptyValues = true
    elements?.forEach((element) => {
      if (!element.type || !element.alias) {
        emptyValues = false
      }
    })
    return emptyValues
  }

  const mandatoryFieldListener = (key, enableUpdate) => {
    // mandatoryFieldsMissing[key] = enableUpdate
  }

  const columnNameValidator = (output) => {
    let valid = true
    for (let i = 0; i < output?.length; i++) {
      if (!output[i]?.column_name || !output[i]?.data_type) {
        valid = false
        break
      }
    }
    return valid
  }
  const checkIfNull = (data, field, missingFields) => {
    if (data && (!data.hasOwnProperty(field) || !data[field])) {
      missingFields.push(field)
    }else if(Array.isArray(data[field]) && data[field].length<=0){
      missingFields.push(field)
    }
  }

  const getMissingFields = (data, fields) => {
    let missingFields = []
    fields.forEach((field) => {
      if (typeof field == 'string') {
        checkIfNull(data, field, missingFields)
      } else {
        if (field?.mainKey) {
          field.subKeys.forEach(subKey => {
            data[field.mainKey]?.forEach((item) => {
              checkIfNull(item, subKey, missingFields)
            })
          })
        }
      }
    })
    return missingFields
  }

const getCustomMissingFields = (customObject = [], fields) => {
    const missingFields = [];
    
    fields.forEach(field => {
        // Find the object in customObject array that has this field as attribute_type
        const foundAttribute = customObject.find(
            item => item.attribute_type === field
        );
        
        // Add to missingFields if either:
        // 1. The attribute_type wasn't found, or
        // 2. The attribute is empty
        if (!foundAttribute || foundAttribute.attribute === "") {
            missingFields.push(field);
        }
    });
    
    return missingFields;
};

  const checkIfFormIsSubmittable = () => {


      let missingFields = getMissingFields(processDataEdited, [PROCESS_KEYS.process_name, PROCESS_KEYS.environment])
      if (missingFields.length <= 0
        && processDataEdited.hasOwnProperty(PROCESS_KEYS.environment)
        && processDataEdited[PROCESS_KEYS.environment] == 'Transfer_FAST_RedShift') {
        let missingFields2 = getMissingFields(processDataEdited, [PROCESS_KEYS.action, PROCESS_KEYS.team, PROCESS_KEYS.business, PROCESS_KEYS.dataset_name, PROCESS_KEYS.schema])
        missingFields = [...missingFields, ...missingFields2]
      }
      if(
        processDataEdited.hasOwnProperty(PROCESS_KEYS.environment)
        && processDataEdited[PROCESS_KEYS.environment] == 'Transfer_S3_Workdocs') {
        let missingFields2 = getCustomMissingFields(processDataEdited.custom_attributes,[ "BACKUP_WORKDOCS_LOCATION_FOLDER_ID", "BACKUP_WORKDOCS_LOCATION" ] )
        missingFields = [...missingFields, ...missingFields2]
      }

      if (missingFields.length <= 0
        && processDataEdited.hasOwnProperty(PROCESS_KEYS.approval_required)
        && processDataEdited[PROCESS_KEYS.approval_required]) {
        if (!missingFields?.includes(PROCESS_KEYS.approvers)
          && processDataEdited?.hasOwnProperty(PROCESS_KEYS.approvers) && processDataEdited[PROCESS_KEYS.approvers]?.length == 0) {
          missingFields = [...missingFields, PROCESS_KEYS.approvers]
        }
        let missingFields2 = getMissingFields(processDataEdited, [{ mainKey: PROCESS_KEYS.approvers, subKeys: [PROCESS_KEYS.APPROVER_KEYS.alias, PROCESS_KEYS.APPROVER_KEYS.type] }])
        missingFields = [...missingFields, ...missingFields2]

      }


      let approvalDecision = true
      if (!validateSoxRequirements(processDataEdited)) {
        approvalDecision = false
      } else if (processDataEdited.hasOwnProperty(PROCESS_KEYS.approval_required) && processDataEdited[PROCESS_KEYS.approval_required] && processDataEdited.hasOwnProperty(PROCESS_KEYS.approvers)
       && processDataEdited[PROCESS_KEYS.approvers] && processDataEdited[PROCESS_KEYS.approvers].length <= 0) {
        approvalDecision = false
      }
      const delsertCondition = (processDataEdited.hasOwnProperty(PROCESS_KEYS.action) && processDataEdited[PROCESS_KEYS.action] === 'DELSERT' && selectedDelsertKeys?.length < 1) ? false : true
      setEnableEditAction(missingFields.length <= 0 && approvalDecision && delsertCondition && ((isNewProcess && canAdd ) || (isEditMode && canEdit)))
  }

  const validateSoxRequirements = (processDataEdited) => {
    if (processDataEdited.hasOwnProperty(PROCESS_KEYS.sox_approved) && processDataEdited[PROCESS_KEYS.sox_approved]) {
      // if(processDataEdited.hasOwnProperty(PROCESS_KEYS.sox_evidence) && !processDataEdited[PROCESS_KEYS.sox_evidence] && processDataEdited[PROCESS_KEYS.sox_evidence] == ""){
      //   return false
      // }
      if (processDataEdited[PROCESS_KEYS.approvers]?.length < 2) {
        let groupCount = 0
        processDataEdited[PROCESS_KEYS.approvers].forEach((approver) => {
          if(approver[PROCESS_KEYS.APPROVER_KEYS.type] == APPROVER_TYPES.APPROVER_LDAP){
            groupCount = groupCount + 1
          }
        })
        if(groupCount > 0){
          return true
        }else{
          return false
        }
      } else {
        return true
      }
    } else {
      return true
    }
  }


  const delsertPopup = (val) => {
    setDelsertPopupCalledFrom(val)
    setDelsertSubmitPopupVisible(true)
  }

  function getSchema(data) {
    let schema = 'frisco'
    if (currentStage != 'beta' && currentStage != 'dev') {
      if (data?.critical_data && data?.sox_approved) {
        schema = "frisco_sox"
      } else if (data?.critical_data) {
        schema = "frisco_critical"
      } else {
        schema = "frisco_ext"
      }
    }
    return schema
  }

  const addProcessDetails = () => {
    setErrorMessage("")
    let missingFields
    // Get missing keys only if its transfer to fast
    if(processDataEdited[PROCESS_KEYS.environment] === 'Transfer_FAST_RedShift'){
      missingFields = getMissingFields(processDataEdited, [PROCESS_KEYS.process_name, PROCESS_KEYS.action])
    }
    if (missingFields && missingFields.length > 0) {
      setErrorMessage('missing mandatory fields : ' + missingFields.join(","))
    } else if(processDataEdited[PROCESS_KEYS.action] === 'DELSERT' && selectedDelsertKeys?.length <= 0) {
      setErrorMessage('Minimum of 1 DELSERT KEY is required for DELSERT loadtype')
    } else {
      setShowLoadingIcon(true)
      let group_id = getGroup()
  if(group_id){
    processDataEdited[PROCESS_KEYS.group_id] = group_id
  }
  let next_step = getParam('next_step')
  if(next_step){
    processDataEdited[PROCESS_KEYS.next_step] = next_step
  }

      processDataEdited[PROCESS_KEYS.last_updated_by] = userId
      processDataEdited[PROCESS_KEYS.created_by] = userId
      processDataEdited[PROCESS_KEYS.step_function_name] = STEP_FUNCTION_CONFIG.find((c) => c.environment === currentStage)?.arn; 
      processDataEdited[PROCESS_KEYS.glue_job_name] = GLUE_JOB_CONFIG.find((c) => c.environment === currentStage)?.name
      // adding column index and prev_column_name
      processDataEdited[PROCESS_KEYS.schema] && processDataEdited[PROCESS_KEYS.schema].length > 0 &&  processDataEdited[PROCESS_KEYS.schema].forEach((columnObj, i) => {
        columnObj[PROCESS_KEYS.SCHEMA_KEYS.column_index] = i+1;
        columnObj[PROCESS_KEYS.SCHEMA_KEYS.prev_column_name] = null;
      })

      // IF there is no transfer to reddshift, there is no table to be created
      if(processDataEdited[PROCESS_KEYS.environment] === 'Transfer_FAST_RedShift'){
        processDataEdited[PROCESS_KEYS.status] = FRISCO_TABLE_STATUS.CREATING_TABLE
      }else{
        processDataEdited[PROCESS_KEYS.status] = FRISCO_TABLE_STATUS.NO_TABLE_TO_BE_CREATED
      }

      createAuditLog(`FRISCO`,`ADD_REQ#${getCurrentTime()}`, "Adding a process", JSON.stringify({}), JSON.stringify(processDataEdited), "ADD REQ", userId)
      setProcessData(processDataEdited)
      createProcess(processDataEdited, function onSuccess(response) {
        setIsNewProcess(false)
        setProcessData(JSON.parse(JSON.stringify(response.data.createProcessV2)))
        if (tancEnabled) {
          //enable TANC
          enableTANC(response.data.createProcessV2.process_id, 'FRISCO',
            response.data.createProcessV2.hasOwnProperty(PROCESS_KEYS.redshift_table_name) && response.data.createProcessV2[PROCESS_KEYS.redshift_table_name]
              && response.data.createProcessV2[PROCESS_KEYS.redshift_table_name] != 'null' ? `${getSchema(response.data.createProcessV2)}.${response.data.createProcessV2[PROCESS_KEYS.redshift_table_name]}` : null, 'FAST', friscoTempId, 
              function onTANCSuccess(tancResponse) {
                setShowLoadingIcon(false)
                // Update query parameters to reflect the new process without page navigation
                const searchParams = new URLSearchParams(location.search);
                searchParams.set('processId', response.data.createProcessV2.process_id);
                searchParams.set('processPage', 'settings');
                history.replace(`${location.pathname}?${searchParams.toString()}`);
              }, function onTANCFailure(tancResponse) {
                setShowLoadingIcon(false)
              })
        } else {
          setShowLoadingIcon(false)
          // Update query parameters to reflect the new process without page navigation
          const searchParams = new URLSearchParams(location.search);
          searchParams.set('processId', response.data.createProcessV2.process_id);
          searchParams.set('processPage', 'settings');
          history.replace(`${location.pathname}?${searchParams.toString()}`);
        }
        cancelEdition()
      }, function onFailure(error) {
        setErrorMessage(error?.errors[0]?.message)
        setShowLoadingIcon(false)
      })
    }
  }

  const updateProcessDetails = () => {
    setErrorMessage("")
    let missingFields
    if(processDataEdited[PROCESS_KEYS.environment] === 'Transfer_FAST_RedShift'){
      missingFields = getMissingFields(processDataEdited, [PROCESS_KEYS.process_id, PROCESS_KEYS.process_name, PROCESS_KEYS.action])
    }
    if (missingFields && missingFields.length > 0) {
      setErrorMessage('missing mandatory fields : ' + missingFields.join(","))
    } else if(processDataEdited[PROCESS_KEYS.action] === 'DELSERT' && selectedDelsertKeys?.length <= 0) {
      setErrorMessage('Minimum of 1 DELSERT KEY is required for DELSERT loadtype')
    } else {
      setShowLoadingIcon(true)
      let group_id = getGroup()
  if(group_id){
    processDataEdited[PROCESS_KEYS.group_id] = group_id
  }
  let next_step = getParam('next_step')
  if(next_step){
    processDataEdited[PROCESS_KEYS.next_step] = next_step
  }
      processDataEdited[PROCESS_KEYS.last_updated_by] = userId
      if (updateComments) {
        setErrorMessage("")
        // add an audit log
        createAuditLog(`FRISCO#${pid}`, `${getCurrentTime()}`, updateComments, JSON.stringify(processData), JSON.stringify(processDataEdited), "UPDATE REQ", userId)
        setUpdateComments("")
        // Updating Column Index and prev_column_name
        if(processDataEdited[PROCESS_KEYS.environment] === 'Transfer_FAST_RedShift'){
          processDataEdited[PROCESS_KEYS.schema].forEach((columnObj, i) => {
            columnObj[PROCESS_KEYS.SCHEMA_KEYS.column_index] = i+1

            if (!columnObj.hasOwnProperty(PROCESS_KEYS.SCHEMA_KEYS.prev_column_name) || columnObj[PROCESS_KEYS.SCHEMA_KEYS.prev_column_name] === columnObj[PROCESS_KEYS.SCHEMA_KEYS.column_name]){
              columnObj[PROCESS_KEYS.SCHEMA_KEYS.prev_column_name] = null;
            }

          })
          processDataEdited[PROCESS_KEYS.status] = FRISCO_TABLE_STATUS.UPDATE_IN_PROGESS
          processDataEdited[PROCESS_KEYS.clear_table_data_on_update] = deleteDataOnUpdate
        }
        setProcessData(processDataEdited)
        updateProcess(processDataEdited, function onSuccess(response) {
         
        }, function onFailure(error) {

        })

        // Do TANC side effects only if fast transfer redshift 
        if(processDataEdited[PROCESS_KEYS.environment] === 'Transfer_FAST_RedShift'){
          const isSchemaSame = JSON.stringify(processData?.[PROCESS_KEYS.schema].sort()) === JSON.stringify(processDataEdited?.[PROCESS_KEYS.schema].sort());

          if (tancEnabled != tancEnabledExistingStatus) {
            if (tancEnabled) {
              //enable TANC
              enableTANC(pid, 'FRISCO', `${getSchema(processDataEdited)}.${processDataEdited?.[PROCESS_KEYS.redshift_table_name]?.replace(/['"]/g, '')}`, 'FAST', friscoTempId, function onSuccess(tancResponse) {
              }, function onFailure(tancResponse) {
                setShowLoadingIcon(false)
              })
              } else {
                //disable TANC
                let tancId = tancInfo?.tanc_id
                disableTANC(tancId, pid, 'FRISCO', function onSuccess(tancResponse) {
                }, function onFailure(tancResponse) {
                  setShowLoadingIcon(false)
                })
              }
            }else if(!isSchemaSame && tancEnabled){ 
              reloadTANCConfigurationForFRISCO(tancInfo?.tanc_id, pid, 'FRISCO', function onSuccess(tancResponse) {
                  }, function onFailure(tancResponse) {
                    setShowLoadingIcon(false)
              })
          }
        }
        setIsNewProcess(false)
        setShowLoadingIcon(false)
        cancelEdition()
        setUpdateNotificationModal(true)
      } else {
        setShowLoadingIcon(false)
        setErrorMessage("Please provide your comments for the update")
      }
      
    }
  }

  const cancelEdition = () => {
    setErrorMessage("")
    setIsEditMode(false)
    setProcessDataEdited(processData)
  }

  const editProcess = () => {
    setIsEditMode(true)
    setProcessDataEdited({ ...processData })
  }

  const delProcess = () => {
    if(updateComments){
      setShowLoadingIcon(true)
    dismissDeleteDialog()
      setModalError("")
      createAuditLog(`FRISCO#${pid}`,`${getCurrentTime()}`, updateComments, JSON.stringify(processData), JSON.stringify({}), "DELETE REQ", userId)
      setUpdateComments("")
      deleteProcess(pid)
      setShowLoadingIcon(false)
      setDeleteConfirmationModal(false)
      setDeleteNotificationModal(true)
    }else{
      setModalError("Please provide comments with the reason for deletion")
    }
    

  }

  const getDate = (value) => {
    var d = new Date(value)
    return d.toLocaleString()
  }

  const lastUpdatedContent = (<>
    {getValue(PROCESS_KEYS.last_updated_time_stamp) ? <>

      <span className="last_updated"> Last updated : <span className="bold">{getDate(getValue(PROCESS_KEYS.last_updated_time_stamp))}</span></span>
      {getValue(PROCESS_KEYS.last_updated_by) ? <span className="last_updated"> &nbsp; by  <span className="bold">{getValue(PROCESS_KEYS.last_updated_by)}</span></span> : ''}
    </> : ''}
  </>)

  const getStatusIcon = (status) => {
    const positiveStatuses = FRISCO_POSITIVE_STATUS
    const negativeStatuses = FRISCO_NEGATIVE_STATUS
    if (positiveStatuses.includes(status)) {
      return <Icon name='status-positive' variant='success' ></Icon>
    } else if (negativeStatuses.includes(status)) {
      return <Icon name='status-negative' variant='error' ></Icon>
    } 
    else {
      return <Icon name='status-in-progress' variant='normal' ></Icon>
    }
  }

  const allowActionOnNotificationMultiple = () => {
    setIsActionOnNotificationPending(true)
    for(let i=0;i<selectedActionableNotificationItems.length;i++){
      selectedActionableNotificationItems[i]['id'] = String(selectedActionableNotificationItems[i]['id'])
      if(selectedActionableNotificationItems[i].hasOwnProperty('sub_id') && selectedActionableNotificationItems[i]['sub_id']){
        selectedActionableNotificationItems[i]['sub_id'] = String(selectedActionableNotificationItems[i]['sub_id'])
      }
    }
    updateAliasToCurrentStateMultiple(selectedActionableNotificationItems, function onSuccess(response){
      loadData()
    }, function onFailure(response){
      setIsActionOnNotificationPending(false)
    })
  }

  const allowActionOnNotification = (notification) => {
    for(let i=0;i<actionableNotificationItems.length; i++){
      if(actionableNotificationItems[i]['id'] ==notification['id'] 
        && actionableNotificationItems[i]['id_type'] ==notification['id_type'] 
        && actionableNotificationItems[i]['notification_type'] ==notification['notification_type']
        && actionableNotificationItems[i]['sub_id'] ==notification['sub_id']
        && actionableNotificationItems[i]['sub_type'] ==notification['sub_type'] ){
          actionableNotificationItems[i]['updating']=true
          setActionableNotificationItems([...actionableNotificationItems])
          break
        }
    }
    updateAliasToCurrentState(notification, function onSuccess(response){
      loadData()
    }, function onFailure(response){
      
    })
  }

  const rerunAliasPatrol = () => {
    setIsActionOnNotificationPending(true)
    auditSOXFRISCO(pid, function onSuccess(response){
      /* Alias patrol verifies and posts the message to SNS - which is then caught by FRISCO to update notification.
       Hence adding a anticipated 2s delay to wait for the event cycle to complete */
      setTimeout(() => {
        loadData()
      }, 10000); 
  
    }, function onFailure(response){
      setIsActionOnNotificationPending(false)
    })
  }
  
  const getAliasInfo = (info) => {
    let split = info.split(":")
    if(split.length > 1){
      return `${split[0]} (${split[1]})`
    }else{
      return info
    }
  }
  const PREFERENCE_VARIABLE_INFO = <Box>Supported variables : Any input parameters and {'{'}process_name{'}'}, {'{'}file_id{'}'}, {'{'}current_quarter{'}'}, {'{'}previous_quarter{'}'}, {'{'}month{'}'}, {'{'}previous_month{'}'}, {'{'}year{'}'}, {'{'}current_year{'}'}, {'{'}previous_year{'}'}, {'{'}previous_month_year{'}'}, {'{'}current_month_year{'}'}, {'{'}label{'}'}, {'{'}wb_type{'}'}, {'{'}wb_status{'}'}, {'{'}deliverable_reference{'}'}</Box>

  const dataClasificationContent = (
    <Box>
    <SpaceBetween direction="horizontal" size="m">
      <Box>Data Generation Platform: <span className={dataGenerationPlatformClass}>{dataGenerationPlatform}</span></Box>
      <Box>Data Share Platform: <span className={dataSharePlatformClass}> {dataSharePlatform} </span></Box>
    </SpaceBetween>
    </Box>
  )

  const notificationConfigurationContent = (
    <SpaceBetween direction="vertical">
      <Box>
        <Box float="left" textAlign="left">
          <Box variant="h1">Email Notification Preference</Box>
        </Box>
      </Box>
      <RadioGroup
        onChange={({ detail }) => updateValueCustomAttributes('NOTIFICATION_PREFERENCE', detail.value)}
        value={getValueCustomAttributes('NOTIFICATION_PREFERENCE') || 'DEFAULT'}
        items={[
          { value: "DEFAULT", label: "Send all (default)", description: "Receive all email notifications including status updates and approval requests" },
          { value: "DISABLE_STATUS", label: "Disable status notifications", description: "Only receive approval request emails, no status update notifications" },
          { value: "DISABLE_ALL", label: "Disable status & approval notifications", description: "No email notifications will be sent (not even approval emails)" },
        ]}
        readOnly={!isEditMode}
      />
    </SpaceBetween>
  )

  const emailConfigurationContent = (
    getValueCustomAttributes('NOTIFICATION_PREFERENCE') !== 'DISABLE_ALL' && (
    <SpaceBetween direction="vertical">
      <Box float="left" textAlign="left">
        <Box variant="h1">Email Customization</Box>
      </Box>
      <SpaceBetween direction="vertical" size="m">
        {getValueCustomAttributes('NOTIFICATION_PREFERENCE') !== 'DISABLE_STATUS' && (
          <Box>
            <SpaceBetween direction="horizontal" size="s">

              <Box variant="h4">Notification Email Title</Box>
              <Popover
                dismissButton={false}
                position="top"
                size="small"
                triggerType="custom"
                content={PREFERENCE_VARIABLE_INFO}
              >
                <Button variant="inline-link">info</Button>
              </Popover>
            </SpaceBetween>
            {
              isEditMode ?
                <CustomInput field='NOTIFICATION_EMAIL_TITLE' placeholder="Custom notification email title (supports variables)" updateValue={updateValueCustomAttributes} getValue={getValueCustomAttributes}></CustomInput>
                : <Box>{getCustomAttribute('NOTIFICATION_EMAIL_TITLE', 'FRISCO')[0] || <Box variant="span" color="text-status-inactive">Not configured</Box>}</Box>
            }
          </Box>
        )}
        
        <Box>
          <SpaceBetween direction="horizontal" size="s">
            <Box variant="h4">Approval Title</Box>
            <Popover
              dismissButton={false}
              position="top"
              size="small"
              triggerType="custom"
              content={PREFERENCE_VARIABLE_INFO}
            >
              <Button variant="inline-link">info</Button>
            </Popover>
          </SpaceBetween>
          {
            isEditMode ?
              <CustomInput field='APPROVAL_TITLE' placeholder="Custom approval title (supports variables)" updateValue={updateValueCustomAttributes} getValue={getValueCustomAttributes}></CustomInput>
              : <Box>{getCustomAttribute('APPROVAL_TITLE', 'FRISCO')[0] || <Box variant="span" color="text-status-inactive">Not configured</Box>}</Box>
          }
        </Box>
        <Box>
          <SpaceBetween direction="horizontal" size="s">
            <Box variant="h4">Approval Description</Box>
            <Popover
              dismissButton={false}
              position="top"
              size="small"
              triggerType="custom"
              content={PREFERENCE_VARIABLE_INFO}
            >
              <Button variant="inline-link">info</Button>
            </Popover>
          </SpaceBetween>
          {
            isEditMode ?
              <Textarea
                onChange={({ detail }) => updateValueCustomAttributes('APPROVAL_DESCRIPTION', detail.value)}
                value={getValueCustomAttributes('APPROVAL_DESCRIPTION') || ''}
                placeholder="Custom approval description (supports variables)"
                rows={3}
              />
              : <Box>{getCustomAttribute('APPROVAL_DESCRIPTION', 'FRISCO')[0] || <Box variant="span" color="text-status-inactive">Not configured</Box>}</Box>
          }
        </Box>
      </SpaceBetween>
    </SpaceBetween>
    ))

  const Content = (
    <>
      {showLoadingIcon ? <Modal visible={showLoadingIcon}>
        <Box>
          <Spinner></Spinner>
          Loading...
        </Box>
      </Modal> :
        <ContentLayout
          headerVariant={props.disableAppLayout ? undefined : "high-contrast"}
          className="content"
          header={
            <SpaceBetween size="l">
              <Header
                variant="h1"
              >

              </Header>

            </SpaceBetween>
          }
        >

          <SpaceBetween size="l" >

            <Flashbar
              items={notificationBarItems}
              i18nStrings={{
                ariaLabel: "Notifications",
                notificationBarAriaLabel:
                  "View all notifications",
                notificationBarText: "Notifications",
                errorIconAriaLabel: "Error",
                warningIconAriaLabel: "Warning",
                successIconAriaLabel: "Success",
                infoIconAriaLabel: "Info",
                inProgressIconAriaLabel: "In progress"
              }}
              stackItems
            />

          {
            alertErrorMessage?<Alert
            statusIconAriaLabel="Error"
            type="error"
            header={alertErrorMessage?.header}
          >
            {alertErrorMessage?.message}
          </Alert>:''
          }

            {
              actionableNotificationItems?.length > 0 ? <>
                <Container>
                  <Table
                    columnDefinitions={[
                      {
                        id: "notification_message",
                        header: "Notification",
                        cell: item => item.notification_message,
                        sortingField: "notification_message",
                        isRowHeader: true,
                      },
                      {
                        id: "info",
                        header: "Info",
                        cell: item => getAliasInfo(item.info),
                        sortingField: "info",
                        width: 250
                      },
                      // {
                      //   id: "action",
                      //   header: "Action",
                      //   cell: item => <SpaceBetween size='xs' direction="horizontal">
                      //      {/* <Button variant="inline-link" onClick={editProcess}><span className="red_badge">Update</span></Button>  */}
                      //   {
                      //     JSON.stringify(item?.updating) == 'true' ?
                      //     <span className="grey_badge"> Updating </span>:
                      //     <Button variant="inline-link" onClick={() => {
                      //       allowActionOnNotification(item)
                      //     }}><span className="green_badge"> Allow </span></Button>
                          
                      //   }
                      //    <Button variant="inline-link" onClick={() => rerunAliasPatrol(item)}>validate</Button></SpaceBetween>
                      // }
                    ]}
                    onSelectionChange={({ detail }) =>
                      setSelectedActionableNotificationItems(detail.selectedItems)
                    }
                    selectedItems={selectedActionableNotificationItems}
                    header={
                      <Header
                        actions={
                          <SpaceBetween
                            direction="horizontal"
                            size="xs"
                          >
                            <Button onClick={() => {
                             rerunAliasPatrol()
                           }}
                           disabled={isActionOnNotificationPending}>
                            Re-validate</Button>
                            <Button variant="primary" onClick={() => {
                             allowActionOnNotificationMultiple()
                           }}
                           disabled={isActionOnNotificationPending || selectedActionableNotificationItems?.length <= 0}
                           >
                            Allow
                            </Button>
                          </SpaceBetween>
                        }
                      >
                        Notifications
                      </Header>
                    }
                    resizableColumns
                    enableKeyboardNavigation
                    items={actionableNotificationItems}
                    loadingText="Loading notifications"
                    sortingDisabled
                    selectionType="multi"
                    variant="embedded"
                    empty={
                      <Box
                        margin={{ vertical: "xs" }}
                        textAlign="center"
                        color="inherit"
                      >
                        <SpaceBetween size="m">
                          <b>No notifications</b>
                        </SpaceBetween>
                      </Box>
                    }
                  />
                </Container>
              </> : ''
            }

            <Container
            >
              <SpaceBetween direction="vertical">
                <SpaceBetween direction="horizontal">
                  <Box variant="h1">Process Details</Box>
                  {
                    // Show the edit button IF upload is to workdocs or if schema status is true if its fast upload
                    !isEditMode && canEdit && (schemaStatus || processDataEdited[PROCESS_KEYS.environment] === 'Transfer_S3_Workdocs')?
                      <Button iconName="edit" variant="icon" onClick={editProcess} /> : <></>
                  }
                  {
                    // Show the delete button IF upload is to workdocs or if schema status is true if its fast upload
                    !isEditMode && canDelete && (schemaStatus || processDataEdited[PROCESS_KEYS.environment] === 'Transfer_S3_Workdocs')?
                      <Button iconName="remove" variant="icon" onClick={() => { setDeleteConfirmationModal(true) }} /> : <></>
                  }
                  <Modal
                    onDismiss={dismissDeleteDialog}
                    visible={deleteConfirmationModal}
                    footer={
                      <Box float="right">
                        <SpaceBetween direction="horizontal" size="xs">
                          <Button variant="link" onClick={dismissDeleteDialog} >Cancel</Button>
                          <Button disabled={deleteAppName !== processData[PROCESS_KEYS.process_name]} variant="primary" onClick={delProcess}  >Confirm</Button>
                        </SpaceBetween>
                      </Box>
                    }
                    header={
                      <React.Fragment>
                        <Box variant="h2">
                          Delete confirmation for '{processData[PROCESS_KEYS.process_name]}'
                        </Box>
                      </React.Fragment>
                    }
                  >
                    <SpaceBetween direction="vertical" size="m">
                      <Box>To confirm deletion, enter the name of the process in the text input field below</Box>
                      <Box>
                        <Input placeholder={processData[PROCESS_KEYS.process_name]} onChange={({ detail }) => setDeleteAppName(detail.value)} value={deleteAppName} />
                      </Box>
                      <Box>
                        <Textarea
                          class="description"
                          onChange={({ detail }) => setUpdateComments(detail.value)}
                          value={updateComments}
                          placeholder="Comments"
                        ></Textarea>
                      </Box>
                      <Box>
                        {modalError && (
                          <Box variant="p" color="text-status-error">
                            {modalError}
                          </Box>
                        )}
                      </Box>
                    </SpaceBetween>
                  </Modal>
                  <Modal
                    onDismiss={dismissDeleteNotifyDialog}
                    visible={deleteNotificationModal}
                    footer={
                      <Box float="right">
                        <SpaceBetween direction="horizontal" size="xs">
                          <Button variant="primary" onClick={dismissDeleteNotifyDialog}>Okay</Button>
                        </SpaceBetween>
                      </Box>
                    }
                    header={
                      <React.Fragment>
                        <Box variant="h2">
                          Delete scheduled for '{processData[PROCESS_KEYS.process_name]}'
                        </Box>
                      </React.Fragment>
                    }
                  >
                    <SpaceBetween direction="vertical" size="m">
                      <Box><Icon name="status-positive" variant="success" /> Process is scheduled to be deleted, please check back after 5 minutes.</Box>
                    </SpaceBetween>
                  </Modal>
                  <Modal
                    onDismiss={dismissUpdateNotifyDialog}
                    visible={updateNotificationModal}
                    footer={
                      <Box float="right">
                        <SpaceBetween direction="horizontal" size="xs">
                          <Button variant="primary" onClick={dismissUpdateNotifyDialog}>Okay</Button>
                        </SpaceBetween>
                      </Box>
                    }
                    header={
                      <React.Fragment>
                        <Box variant="h2">
                          Update scheduled for '{processData[PROCESS_KEYS.process_name]}'
                        </Box>
                      </React.Fragment>
                    }
                  >
                    <SpaceBetween direction="vertical" size="m">
                      <Box><Icon name="status-positive" variant="success" /> Process is scheduled to be updated, please check back after 5 minutes.</Box>
                    </SpaceBetween>
                  </Modal>
                </SpaceBetween>
                <Box >{lastUpdatedContent}</Box>
                <br></br>
              </SpaceBetween>
              
              <SpaceBetween size="l">
              {
                  !isEditMode?
                  <SpaceBetween direction="horizontal" size="m">
                            {
                              processData.hasOwnProperty(PROCESS_KEYS.approval_required) 
                              && processData[PROCESS_KEYS.approval_required]?
                              <Box><span className='orange_badge'>Approval required</span></Box>
                              :<></>
                            }
                            {
                              processData.hasOwnProperty(PROCESS_KEYS.sox_approved) 
                              && processData[PROCESS_KEYS.sox_approved]?
                              <Box><span className='green_badge'> 2 touch approval  </span></Box>
                              :<></>
                            }
                            {
                              isQueuedExecution && <Box><span className='blue_badge'>Queued executions</span></Box>
                            }
                          
                  </SpaceBetween>
                          :
                          <></>
                }
                {

                  (!isNewProcess  && processData[PROCESS_KEYS.environment] === 'Transfer_FAST_RedShift' ) ? 
                  <SpaceBetween direction="vertical" size="s">
                    <SpaceBetween size="s" direction="horizontal">
                      {(processData.hasOwnProperty(PROCESS_KEYS.status) && processData[PROCESS_KEYS.status] ) ?
                          <>
                            <Box>Status :</Box>
                            <SpaceBetween direction="horizontal" size="s"> {getStatusIcon(processData[PROCESS_KEYS.status])}
                              <span className="small_grey_text_italics">{processData[PROCESS_KEYS.status]}</span></SpaceBetween> 
                          </>
                          : 'Unknown'
                      }
                      
                      
                    </SpaceBetween>
                    <SpaceBetween size="s" direction="horizontal">
                      {(processData.hasOwnProperty(PROCESS_KEYS.redshift_table_name) && processData[PROCESS_KEYS.redshift_table_name]) ? 
                      <>
                        <Box>Table :</Box>
                        <Box>{processData[PROCESS_KEYS.redshift_table_name]}</Box>
                      </>
                      : ''
                      }
                    </SpaceBetween>
                  </SpaceBetween> : ''
                }


                {flashBarComments ? <Flashbar items={flashBarComments} /> : <></>}
                <ColumnLayout columns={2}>
                  <div>
                    <Box variant="h4">Process Name{isEditMode && <Box variant="span" color="text-status-error"> *</Box>}</Box>
                    {
                      isEditMode ?
                        <CustomInput field={PROCESS_KEYS.process_name} placeholder="Process name" updateValue={updateValue} getValue={getValue} maxLength={getProcessNameMaxLength(currentAppId, currentStage)}></CustomInput>
                        : processData?.hasOwnProperty(PROCESS_KEYS.process_name) ? processData[PROCESS_KEYS.process_name] : ''
                    }
                  </div>
                  <div>
                    <Box variant="h4">Label - To display in the application page</Box>
                    {
                      isEditMode ?
                        <CustomInput field={PROCESS_KEYS.label} placeholder="label" updateValue={updateValue} getValue={getValue}></CustomInput>
                        : processData?.hasOwnProperty(PROCESS_KEYS.label) ? processData[PROCESS_KEYS.label] : ''
                    }
                  </div>
                  <div>
                    <Box variant="h4">Description</Box>
                    {
                      isEditMode ?
                        <Textarea
                          class="description"
                          onChange={({ detail }) => updateValue(PROCESS_KEYS.description, detail.value)}
                          value={getValue(PROCESS_KEYS.description)}
                          placeholder="Description"
                        />
                        : processData?.hasOwnProperty(PROCESS_KEYS.description) ? processData[PROCESS_KEYS.description] : ''
                    }
                  </div>

                  <div>
                    <RadioGroup
                      onChange={({ detail }) => {
                        processDataEdited[PROCESS_KEYS.environment] = detail.value

                        // We need to transfer to upload to workdocs if the radio they select is Transfer to workdocs
                        if(detail.value === "Transfer_S3_Workdocs"){
                          updateValueCustomAttributes('BACKUP_WORKDOCS_LOCATION_ENABLED', "true")
                        }else{
                          updateValueCustomAttributes('BACKUP_WORKDOCS_LOCATION_ENABLED', "false")
                        }

                        setProcessDataEdited({ ...processDataEdited })
                        setProcessData({ ...processDataEdited })
                      }}
                      value={processDataEdited[PROCESS_KEYS.environment]}
                      // Disable This radio IF any of the following two conditions are met
                      // 1. If we are not in edit mode (If we are viewing the FRISCO)
                      // 2. If its not a new process we won't want to allow editing
                      items={[
                        { value: "Transfer_FAST_RedShift", label: "File load to FAST Redshift", disabled: !isEditMode || !isNewProcess  },
                        { value: "Transfer_S3_Workdocs", label: "File transfer to Workdocs/S3", disabled: !isEditMode || !isNewProcess },
                        { value: "Extract_PDF_data", label: "Extract PDF Data", disabled: true }
                      ]}
                    />
                  </div>

                </ColumnLayout>
              </SpaceBetween>
              <br/>

              <SpaceBetween size="m">
                {((processDataEdited[PROCESS_KEYS.environment] === 'Transfer_S3_Workdocs' || processData[PROCESS_KEYS.environment] === 'Transfer_S3_Workdocs') ) &&(
                  <>
                    <Box variant="h4">Configuration:</Box>
                    <CustomCheckbox field={PROCESS_KEYS.approval_required} getValue={getValue} updateValue={updateValue} text="Additional Approval required" disabled={isApprovalDisabled || !isEditMode} />

                      <div>
                        <Box variant="h4">Load file type{isEditMode && (processDataEdited[PROCESS_KEYS.environment] === 'Transfer_S3_Workdocs') && <Box variant="span" color="text-status-error"> *</Box>}</Box>
                        {
                          isEditMode ?
                            <CustomMultiSelect field={PROCESS_KEYS.file_types} updateValue={updateValue} getValues={getSelectFieldValues} getSelectedOptions={getMultiSelectedOptions} />
                            : processData?.hasOwnProperty(PROCESS_KEYS.file_types) ?
                              <ul>
                                {processData[PROCESS_KEYS.file_types]?.map((item) => (
                                  <li key={item} className="list-item-data">
                                    {item}
                                  </li>
                                ))}
                              </ul>
                              : ''
                        }
                      </div>

                    <Box variant="h4">Workdocs Upload Details{isEditMode && <Box variant="span" color="text-status-error"> *</Box>}</Box>
                    {
                      isEditMode ?
                      <SpaceBetween direction="vertical" size="xxs">
                          <CustomInput field="BACKUP_WORKDOCS_LOCATION_FOLDER_ID" placeholder="Workdocs folder id" updateValue={updateValueCustomAttributes} getValue={getValueCustomAttributes}></CustomInput>
                      <SpaceBetween direction="vertical" size="xxxs">
                              <Box><span className="last_updated"> The field below creates a subfolder automatically using dynamic variables for the path. Use the variables mentioned below for dynamic values. </span></Box>
                              <Box><span className="last_updated bold">Supported variables :  {'{'}process_name{'}'}, {'{'}file_id{'}'}, {'{'}current_quarter{'}'}, {'{'}previous_quarter{'}'}, {'{'}month{'}'}, {'{'}previous_month{'}'}, {'{'}year{'}'}, {'{'}current_year{'}'}, {'{'}previous_year{'}'}, {'{'}previous_month_year{'}'}, {'{'}current_month_year{'}'}, {'{'}process_label{'}'}, {'{'}wb_status{'}'}, {'{'}alias{'}'}</span></Box>
                              <Box><span className="last_updated"> Ex: frisco/{'{'}current_quarter{'}'}-{'{'}year{'}'}/upload will be frisco/q1-2024/backup </span></Box>
                            </SpaceBetween>
                            <CustomInput field="BACKUP_WORKDOCS_LOCATION" placeholder="Workdocs subfolder path" updateValue={updateValueCustomAttributes} getValue={getValueCustomAttributes}></CustomInput>

                            </SpaceBetween>
                        : 
                        <ColumnLayout columns={2}>
                            <div>
                        <Box variant="h4">Workdocs folder id</Box>
                        <Box>{getCustomAttribute('BACKUP_WORKDOCS_LOCATION_FOLDER_ID', 'FRISCO')[0]}</Box>
                        </div>
                        <div>
                        <Box variant="h4">Workdocs sub folder</Box>
                        <Box>{getCustomAttribute('BACKUP_WORKDOCS_LOCATION', 'FRISCO')[0]}</Box>
                        </div>
                          </ColumnLayout>    
                    }
                    {
                      isEditMode ?
                      <SpaceBetween direction="vertical" size="xxs">
                              <Box><span className="last_updated">The field below determines the file name format to the documents uploaded in this FRISCO</span></Box>
                              <Box><span className="last_updated bold">Supported variables :  {'{'}process_name{'}'}, {'{'}file_id{'}'}, {'{'}current_quarter{'}'}, {'{'}previous_quarter{'}'}, {'{'}month{'}'}, {'{'}previous_month{'}'}, {'{'}year{'}'}, {'{'}current_year{'}'}, {'{'}previous_year{'}'}, {'{'}previous_month_year{'}'}, {'{'}current_month_year{'}'}, {'{'}process_label{'}'}, {'{'}wb_status{'}'}, {'{'}uploaded_file_name{'}'}, {'{'}alias{'}'} </span></Box>
                              <Box><span className="last_updated"> Ex: for [{'{'}current_quarter{'}'}][{'{'}current_year{'}'}] the file name will be [q1][2024] </span></Box>
                            <CustomInput field="FILE_PREFIX" placeholder="Workdocs file prefix" updateValue={updateValueCustomAttributes} getValue={getValueCustomAttributes}></CustomInput>

                            </SpaceBetween>
                        : 
                        <ColumnLayout columns={2}>
                        <div>
                        <Box variant="h4">Workdocs file prefix</Box>
                        <Box>{getCustomAttribute('FILE_PREFIX', 'FRISCO')[0]}</Box>
                        </div>
                          </ColumnLayout>    
                    }
                      <ColumnLayout columns={2}>
                        <div>
                          <SpaceBetween direction="vertical">
                            <div className="header_menu">
                              <div className="header_left">
                                <Box variant="h1">Uploader(s) Details</Box>
                              </div>
                            </div>
                            {
                              isEditMode ?
                                <CustomMultiHybridInputAndSelect field={PROCESS_KEYS.uploaders}
                                  inputKey={PROCESS_KEYS.UPLOADER_KEYS.alias} selectKey={PROCESS_KEYS.UPLOADER_KEYS.type} selectHint="Choose type"
                                  placeholder="alias" getValues={getValue} postProcess={postProcessTeamEmails} validator={approversValidation} mandatoryFieldListener={mandatoryFieldListener}
                                  updateValue={updateValue} getOptions={getSelectFieldValues} info=' ' errorMessage='type and alias input are mandatory' duplicatesNotAllowed={true} 
                                  loginOptions={suggestedLogins} getLoginOptions={getSuggestedLoginsCaller} aliasesLoading={aliasesLoading}/>
                                  
                                :
                                <div>
                                  {getValue(PROCESS_KEYS.uploaders) ? <Table
                                    columnDefinitions={[
                                      {
                                        id: "variable",
                                        header: "Type",
                                        cell: item => (item[PROCESS_KEYS.UPLOADER_KEYS.type] == UPLOADER_TYPES.UPLOADER ? 'USER' : 'LDAP') || "-",
                                        isRowHeader: true
                                      },
                                      {
                                        id: "alt",
                                        header: "Alias",
                                        cell: item => item[PROCESS_KEYS.UPLOADER_KEYS.alias] || "-",
                                        sortingField: "alt"
                                      }
                                    ]}
                                    items={getValue(PROCESS_KEYS.uploaders)}
                                    loadingText="Loading uploaders details"
                                    sortingDisabled
                                    empty={
                                      <Box
                                        margin={{ vertical: "xs" }}
                                        textAlign="center"
                                        color="inherit"
                                      >
                                        <SpaceBetween size="m">
                                          <b>No uploaders yet</b>
                                        </SpaceBetween>
                                      </Box>
                                    }
                                    variant='embedded'
                                  /> : ''}
                                </div>
                            }

                          </SpaceBetween>
                        </div>

                        {
                          (processData?.approval_required || processDataEdited?.approval_required) ?
                            <SpaceBetween>
                              <br></br>
                              <div>
                                <SpaceBetween direction="vertical">
                                  <div className="header_menu">
                                    <div className="header_left">
                                      <Box variant="h1">Approver(s) Details</Box>
                                    </div>
                                  </div>
                                  {
                                    isEditMode ?
                                      <CustomMultiHybridInputAndSelect field={PROCESS_KEYS.approvers}
                                        inputKey={PROCESS_KEYS.APPROVER_KEYS.alias} selectKey={PROCESS_KEYS.APPROVER_KEYS.type} selectHint="Choose type"
                                        placeholder="alias" getValues={getValue} postProcess={postProcessTeamEmails} validator={approversValidation} mandatoryFieldListener={mandatoryFieldListener}
                                        updateValue={updateValue} getOptions={getSelectFieldValues} info=' ' errorMessage='type and alias input are mandatory' duplicatesNotAllowed={true}
                                        needIndex={true} indexKey={PROCESS_KEYS.APPROVER_KEYS.column_index} indexPlaceHolder="Order of approval" defIndex={0}
                                        loginOptions={suggestedLogins} getLoginOptions={getSuggestedLoginsCaller} aliasesLoading={aliasesLoading}
                                        />
                                      :
                                      <div>
                                        {getValue(PROCESS_KEYS.approvers) ? <Table
                                          columnDefinitions={[
                                            {
                                              id: "variable",
                                              header: "Type",
                                              cell: item => (item[PROCESS_KEYS.APPROVER_KEYS.type] == APPROVER_TYPES.APPROVER ? 'USER' : 'LDAP') || "-",
                                              isRowHeader: true
                                            },
                                            {
                                              id: "alt",
                                              header: "Alias",
                                              cell: item => item[PROCESS_KEYS.APPROVER_KEYS.alias] || "-",
                                              sortingField: "alt"
                                            }
                                          ]}
                                          items={getValue(PROCESS_KEYS.approvers)}
                                          loadingText="Loading approver details"
                                          sortingDisabled
                                          empty={
                                            <Box
                                              margin={{ vertical: "xs" }}
                                              textAlign="center"
                                              color="inherit"
                                            >
                                              <SpaceBetween size="m">
                                                <b>No approvers yet</b>
                                              </SpaceBetween>
                                            </Box>
                                          }
                                          variant='embedded'
                                        /> : ''}
                                      </div>
                                  }

                                </SpaceBetween>
                              </div>

                            </SpaceBetween> : <></>
                        }
                      </ColumnLayout>
                  </>
                )}

                {(processDataEdited[PROCESS_KEYS.environment] == 'Transfer_FAST_RedShift' || processData[PROCESS_KEYS.environment] == 'Transfer_FAST_RedShift') ?
                  <><SpaceBetween>
                    <ColumnLayout columns={2}>
                      <div>
                        <Box variant="h4">Load type{isEditMode && <Box variant="span" color="text-status-error"> *</Box>}</Box>
                        {
                          isEditMode ? 
                            <CustomSelect field={PROCESS_KEYS.action} getValue={getValue} updateValue={updateValue} getOptions={getSelectFieldValues} />
                            : processData?.hasOwnProperty(PROCESS_KEYS.action) ? processData[PROCESS_KEYS.action] : ''
                        }
                        
                      </div>

                      <div>
                        <Box variant="h4">Load file type{isEditMode && <Box variant="span" color="text-status-error"> *</Box>}</Box>
                        {
                          isEditMode ?
                            <CustomMultiSelect field={PROCESS_KEYS.file_types} updateValue={updateValue} getValues={getSelectFieldValues} getSelectedOptions={getMultiSelectedOptions} />
                            : processData?.hasOwnProperty(PROCESS_KEYS.file_types) ?
                              <ul>
                                {processData[PROCESS_KEYS.file_types]?.map((item) => (
                                  <li key={item} className="list-item-data">
                                    {item}
                                  </li>
                                ))}
                              </ul>
                              : ''
                        }
                      </div>

                      {isEditMode ?
                        <>
                          <div>
                            <Box variant="h4">&nbsp;</Box>
                            <CustomCheckbox field={PROCESS_KEYS.multipart_allowed} getValue={getValue} updateValue={updateValue} text="Multi-part allowed" disabled={true} />
                            <SpaceBetween direction="horizontal" size="s">
                              <SpaceBetween direction="horizontal" size="s">
                              <CustomCheckbox field={PROCESS_KEYS.sox_approved} getValue={getValue} updateValue={updateValue} text="Enable 2 touch approval" disabled={!isNewProcess} />
                              <Button  variant="inline-link" onClick={()=>{setToolsOpen(!toolsOpen)}}>info</Button>
                              </SpaceBetween>
                              {
                                processDataEdited[PROCESS_KEYS.sox_approved]?
                                <Box>
                                <Textarea
                                  class="Notes"
                                  onChange={({ detail }) => updateValue(PROCESS_KEYS.sox_evidence, detail.value)}
                                  value={getValue(PROCESS_KEYS.sox_evidence)}
                                  placeholder="notes"
                                />
                              </Box>:''
                              }
                            </SpaceBetween>
                            <CustomCheckbox field={PROCESS_KEYS.approval_required} getValue={getValue} updateValue={updateValue} text="Approval required" disabled={isApprovalDisabled} />
                            <CustomCheckbox field={PROCESS_KEYS.critical_data} getValue={getValue} updateValue={updateValue} text="Critical data" disabled={!isNewProcess} /> 
                            <Link external href="https://policy.a2z.com/docs/97/publication">Click here to review Amazon policy on Data Classification Standard</Link>
                            <br/>
                            <br/>
                            {dataClasificationContent}
                          </div></> : <>

                          {dataClasificationContent}
                          </>}

                      <div>
                        <Box variant="h4">TANC Configuration</Box>
                        {
                          isEditMode ? <SpaceBetween direction="horizontal" size="m">
                            <Checkbox
                              onChange={({ detail }) =>
                                setTancEnabled(detail.checked)
                              }
                              checked={tancEnabled}
                            >
                              Enable inline editing
                            </Checkbox>
                            {
                              tancEnabled ? <Button variant="normal" onClick={() => setShowTancPermissionModal(true)}>Manage</Button> : <></>
                            }
                          </SpaceBetween> : <>
                            <Checkbox
                              checked={tancEnabled}
                              disabled={!isEditMode}
                            >
                              Enable inline editing
                            </Checkbox>
                          </>
                        }

                        <Modal
                          onDismiss={() => setShowTancPermissionModal(false)}
                          visible={showTancPermissionModal}
                          header="Manage permissions"
                          size="max"
                        >
                          {
                            showTancPermissionModal ? <TANCManager appId={id} userId={userId} isNewParent={isNewProcess} parentInfo={isEditMode ? processDataEdited : processData} parentType={'FRISCO'} tancId={tancInfo?.tanc_id ? tancInfo?.tanc_id : friscoTempId} ref={tancManagerRef}></TANCManager>
                              : <></>
                          }
                        </Modal>
                      </div>
                    </ColumnLayout>
                  </SpaceBetween>
                    <SpaceBetween direction="vertical" size="s">
                    {
                      isEditMode ?
                      <CustomCheckbox field="BACKUP_WORKDOCS_LOCATION_ENABLED" getValue={getValueCustomAttributes} updateValue={updateValueCustomAttributes} text="Backup to workdocs" />
                        : ''
                    }
                    {
                      isEditMode && id == appSettings[currentStage]?.appId ?
                      <CustomCheckbox field="UPLOAD_ONLY_TO_ALIASES" getValue={getValueCustomAttributes} updateValue={updateValueCustomAttributes} text="Only for aliases" />
                        : ''
                    }

                      {
                        isBackupWorkdocsEnabled ?
                        <>
                        {
                      isEditMode ?
                      <SpaceBetween direction="vertical" size="xxs">
                          <CustomInput field="BACKUP_WORKDOCS_LOCATION_FOLDER_ID" placeholder="Workdocs folder id" updateValue={updateValueCustomAttributes} getValue={getValueCustomAttributes}></CustomInput>
                      <SpaceBetween direction="vertical" size="xxxs">
                              <Box><span className="last_updated"> The field below creates a subfolder automatically using dynamic variables for the path. Use the variables mentioned below for dynamic values. </span></Box>
                              <Box><span className="last_updated bold">Supported variables :  {'{'}process_name{'}'}, {'{'}file_id{'}'}, {'{'}current_quarter{'}'}, {'{'}previous_quarter{'}'}, {'{'}month{'}'}, {'{'}previous_month{'}'}, {'{'}year{'}'}, {'{'}current_year{'}'}, {'{'}previous_year{'}'}, {'{'}previous_month_year{'}'}, {'{'}current_month_year{'}'}, {'{'}wb_status{'}'}, {'{'}alias{'}'}</span></Box>
                              <Box><span className="last_updated"> Ex: frisco/{'{'}current_quarter{'}'}-{'{'}year{'}'}/backup will be frisco/q1-2024/backup </span></Box>
                            </SpaceBetween>
                            <CustomInput field="BACKUP_WORKDOCS_LOCATION" placeholder="Workdocs subfolder path" updateValue={updateValueCustomAttributes} getValue={getValueCustomAttributes}></CustomInput>

                            </SpaceBetween>
                        : 
                        <ColumnLayout columns={2}>
                            <div>
                        <Box variant="h4">Workdocs backup folder id</Box>
                        <Box>{getCustomAttribute('BACKUP_WORKDOCS_LOCATION_FOLDER_ID', 'FRISCO')[0]}</Box>
                        </div>
                        <div>
                        <Box variant="h4">Workdocs backup sub folder</Box>
                        <Box>{getCustomAttribute('BACKUP_WORKDOCS_LOCATION', 'FRISCO')[0]}</Box>
                        </div>
                          </ColumnLayout>    
                    }
                    {
                      isEditMode ?
                      <SpaceBetween direction="vertical" size="xxs">
                              <Box><span className="last_updated">The field below determines the file name format to the documents uploaded in this FRISCO</span></Box>
                              <Box><span className="last_updated bold">Supported variables :  {'{'}process_name{'}'}, {'{'}file_id{'}'}, {'{'}current_quarter{'}'}, {'{'}previous_quarter{'}'}, {'{'}month{'}'}, {'{'}previous_month{'}'}, {'{'}year{'}'}, {'{'}current_year{'}'}, {'{'}previous_year{'}'}, {'{'}previous_month_year{'}'}, {'{'}current_month_year{'}'}, {'{'}process_label{'}'}, {'{'}wb_status{'}'}, {'{'}uploaded_file_name{'}'}, {'{'}alias{'}'}</span></Box>
                              <Box><span className="last_updated"> Ex: for [{'{'}current_quarter{'}'}][{'{'}current_year{'}'}] the file name will be [q1][2024] </span></Box>
                            <CustomInput field="FILE_PREFIX" placeholder="Workdocs subfolder path" updateValue={updateValueCustomAttributes} getValue={getValueCustomAttributes}></CustomInput>

                            </SpaceBetween>
                        : 
                        <ColumnLayout columns={2}>
                        <div>
                        <Box variant="h4">Workdocs file prefix</Box>
                        <Box>{getCustomAttribute('FILE_PREFIX', 'FRISCO')[0]}</Box>
                        </div>
                          </ColumnLayout>    
                    }
                        </> : ''
   
                      }
                    </SpaceBetween>

                    <SpaceBetween size="l">
                      <div className="header_menu">
                        <div className="header_left">
                          <Box variant="h1">Dataset Details</Box>
                        </div>
                      </div>
                      <ColumnLayout columns={3}>
                        <div>
                          <SpaceBetween direction="vertical">
                            <Box variant="h4">Team{isEditMode && <Box variant="span" color="text-status-error"> *</Box>}</Box>
                            {
                              isEditMode ?
                                <CustomSelect field={PROCESS_KEYS.team} getValue={getValue} updateValue={updateValue} getOptions={getSelectFieldValues} />
                                :
                                processData.hasOwnProperty(PROCESS_KEYS.team) ? processData[PROCESS_KEYS.team] : '-'
                            }
                          </SpaceBetween>
                        </div>
                        <div>
                          <SpaceBetween direction="vertical">
                            <Box variant="h4">Business{isEditMode && <Box variant="span" color="text-status-error"> *</Box>}</Box>
                            {
                              isEditMode ?
                                <CustomSelect field={PROCESS_KEYS.business} getValue={getValue} updateValue={updateValue} getOptions={getSelectFieldValues} />
                                :
                                processData.hasOwnProperty(PROCESS_KEYS.business) ? processData[PROCESS_KEYS.business] : '-'
                            }
                          </SpaceBetween>
                        </div>
                        <div>
                          <SpaceBetween direction="vertical">
                            <Box variant="h4">Dataset name{isEditMode && <Box variant="span" color="text-status-error"> *</Box>}</Box>
                            {
                              isEditMode ?
                                <CustomInput field={PROCESS_KEYS.dataset_name} placeholder="Dataset name" updateValue={updateValue} getValue={getValue} required={true} mandatoryFieldListener={mandatoryFieldListener}></CustomInput>
                                :
                                processData.hasOwnProperty(PROCESS_KEYS.dataset_name) ? processData[PROCESS_KEYS.dataset_name] : '-'
                            }
                          </SpaceBetween>
                        </div>
                      </ColumnLayout>
                      <ColumnLayout columns={2}>
                        <div>
                          <SpaceBetween direction="vertical">
                            <div className="header_menu">
                              <div className="header_left">
                                <Box variant="h1">Uploader(s) Details</Box>
                              </div>
                            </div>
                            {
                              isEditMode ?
                                <CustomMultiHybridInputAndSelect field={PROCESS_KEYS.uploaders}
                                  inputKey={PROCESS_KEYS.UPLOADER_KEYS.alias} selectKey={PROCESS_KEYS.UPLOADER_KEYS.type} selectHint="Choose type"
                                  placeholder="alias" getValues={getValue} postProcess={postProcessTeamEmails} validator={approversValidation} mandatoryFieldListener={mandatoryFieldListener}
                                  updateValue={updateValue} getOptions={getSelectFieldValues} info=' ' errorMessage='type and alias input are mandatory' duplicatesNotAllowed={true} 
                                  loginOptions={suggestedLogins} getLoginOptions={getSuggestedLoginsCaller} aliasesLoading={aliasesLoading}/>
                                  
                                :
                                <div>
                                  {getValue(PROCESS_KEYS.uploaders) ? <Table
                                    columnDefinitions={[
                                      {
                                        id: "variable",
                                        header: "Type",
                                        cell: item => (item[PROCESS_KEYS.UPLOADER_KEYS.type] == UPLOADER_TYPES.UPLOADER ? 'USER' : 'LDAP') || "-",
                                        isRowHeader: true
                                      },
                                      {
                                        id: "alt",
                                        header: "Alias",
                                        cell: item => item[PROCESS_KEYS.UPLOADER_KEYS.alias] || "-",
                                        sortingField: "alt"
                                      }
                                    ]}
                                    items={getValue(PROCESS_KEYS.uploaders)}
                                    loadingText="Loading uploaders details"
                                    sortingDisabled
                                    empty={
                                      <Box
                                        margin={{ vertical: "xs" }}
                                        textAlign="center"
                                        color="inherit"
                                      >
                                        <SpaceBetween size="m">
                                          <b>No uploaders yet</b>
                                        </SpaceBetween>
                                      </Box>
                                    }
                                    variant='embedded'
                                  /> : ''}
                                </div>
                            }

                          </SpaceBetween>
                        </div>

                        {
                          (processData?.approval_required || processDataEdited?.approval_required) ?
                            <SpaceBetween>
                              <br></br>
                              <div>
                                <SpaceBetween direction="vertical">
                                  <div className="header_menu">
                                    <div className="header_left">
                                      <Box variant="h1">Approver(s) Details</Box>
                                    </div>
                                  </div>
                                  {
                                    isEditMode ?
                                      <CustomMultiHybridInputAndSelect field={PROCESS_KEYS.approvers}
                                        inputKey={PROCESS_KEYS.APPROVER_KEYS.alias} selectKey={PROCESS_KEYS.APPROVER_KEYS.type} selectHint="Choose type"
                                        placeholder="alias" getValues={getValue} postProcess={postProcessTeamEmails} validator={approversValidation} mandatoryFieldListener={mandatoryFieldListener}
                                        updateValue={updateValue} getOptions={getSelectFieldValues} info=' ' errorMessage='type and alias input are mandatory' duplicatesNotAllowed={true}
                                        needIndex={true} indexKey={PROCESS_KEYS.APPROVER_KEYS.column_index} indexPlaceHolder="Order of approval" defIndex={0}
                                        loginOptions={suggestedLogins} getLoginOptions={getSuggestedLoginsCaller} aliasesLoading={aliasesLoading}
                                        />
                                      :
                                      <div>
                                        {getValue(PROCESS_KEYS.approvers) ? <Table
                                          columnDefinitions={[
                                            {
                                              id: "variable",
                                              header: "Type",
                                              cell: item => (item[PROCESS_KEYS.APPROVER_KEYS.type] == APPROVER_TYPES.APPROVER ? 'USER' : 'LDAP') || "-",
                                              isRowHeader: true
                                            },
                                            {
                                              id: "alt",
                                              header: "Alias",
                                              cell: item => item[PROCESS_KEYS.APPROVER_KEYS.alias] || "-",
                                              sortingField: "alt"
                                            }
                                          ]}
                                          items={getValue(PROCESS_KEYS.approvers)}
                                          loadingText="Loading approver details"
                                          sortingDisabled
                                          empty={
                                            <Box
                                              margin={{ vertical: "xs" }}
                                              textAlign="center"
                                              color="inherit"
                                            >
                                              <SpaceBetween size="m">
                                                <b>No approvers yet</b>
                                              </SpaceBetween>
                                            </Box>
                                          }
                                          variant='embedded'
                                        /> : ''}
                                      </div>
                                  }

                                </SpaceBetween>
                              </div>

                            </SpaceBetween> : <></>
                        }
                      </ColumnLayout>
                      <ColumnLayout columns={isEditMode && isNewProcess ? 2 : 1}>
                        <div>
                          <ExpandableSection
                            variant="navigation"
                            defaultExpanded={true}
                            headerText={<span>Schema - columns to validate on input{isEditMode && <Box variant="span" color="text-status-error"> *</Box>}</span>}
                          >
                            {isEditMode  ?
                              (generatingSchemaLoader ? <SpaceBetween size="l"><Box></Box><Box textAlign="center"><Spinner> </Spinner> generating schema... </Box></SpaceBetween> :
                              <>
                                <CustomProcessSchemaInput field={PROCESS_KEYS.schema}
                                  inputKey={PROCESS_KEYS.SCHEMA_KEYS.column_name} selectKey={PROCESS_KEYS.SCHEMA_KEYS.data_type} radioKey={PROCESS_KEYS.SCHEMA_KEYS.mandatory}
                                  scaleKey={PROCESS_KEYS.SCHEMA_KEYS.scale} precisionKey={PROCESS_KEYS.SCHEMA_KEYS.precision} lengthKey={PROCESS_KEYS.SCHEMA_KEYS.length} lastUpdatedTimeKey={PROCESS_KEYS.SCHEMA_KEYS.last_updated_time_stamp}
                                  selectHint="Choose data type" radioText="Mandatory" radioKeyVisible={false} radioKeyDefault={true}
                                  placeholder="column name" getValues={getValue} validator={columnNameValidator}
                                  updateValue={updateValue} getOptions={getSelectFieldValues} info=' ' errorMessage='data type and column name cannot be empty'
                                  delsertKey = {PROCESS_KEYS.SCHEMA_KEYS.delsert_key} delsertRadioKeyVisible={processDataEdited[PROCESS_KEYS.action] === 'DELSERT'} 
                                  delsertRadioText="DELSERT KEY" delsertRadioKeyDefault={false}
                                  nonEmptyColumnKey={PROCESS_KEYS.SCHEMA_KEYS.non_empty_column} nonEmptyColumnRadioKeyVisible={true}
                                  nonEmptyColumnRadioText="Non-empty column" nonEmptyColumnRadioKeyDefault={false}
                                  comparisonOperatorKey={PROCESS_KEYS.SCHEMA_KEYS.comparison_operator}
                                  comparisonValueKey={PROCESS_KEYS.SCHEMA_KEYS.comparison_value}
                                  comparisonTypeKey={PROCESS_KEYS.SCHEMA_KEYS.comparison_type}/>

                                  {(isEditMode && !isNewProcess ?
                                    <>
                                    <br></br>
                                      <Alert statusIconAriaLabel="Warning" type="warning">
                                      If there is schema update, such as data type change. It is possible to encounter failures during the process of copying data into the newly updated schema. 
                                      Our suggestion is to update the data types to accommodate the information in the source table.
                                       <p><strong>Do you want to clear the data in the table while changing the schema?</strong></p>
                                        <Checkbox
                                          onChange={({ detail }) =>
                                            setDeleteDataOnUpdate(detail.checked)
                                          }
                                          checked={deleteDataOnUpdate}
                                        >
                                          Delete existing data
                                        </Checkbox>

                                      </Alert>
                                    </> : <></>)
                                  }

                              </>
                                  
                              )

                              :
                              <div>
                                {getValue(PROCESS_KEYS.schema) ? <Table
                                  columnDefinitions={[
                                    {
                                      id: "alt",
                                      header: "Column name",
                                      cell: item => item[PROCESS_KEYS.SCHEMA_KEYS.column_name] || "-",
                                      sortingField: "alt"
                                    },
                                    {
                                      id: "variable",
                                      header: "Data type",
                                      cell: item => item[PROCESS_KEYS.SCHEMA_KEYS.data_type] || "-",
                                      isRowHeader: true
                                    },
                                    {
                                      id: "length",
                                      header: "Length",
                                      cell: item => item[PROCESS_KEYS.SCHEMA_KEYS.length] || "-",
                                      isRowHeader: true
                                    },
                                    {
                                      id: "scale",
                                      header: "Scale",
                                      cell: item => item[PROCESS_KEYS.SCHEMA_KEYS.scale] || "-",
                                      isRowHeader: true
                                    },
                                    {
                                      id: "precision",
                                      header: "Precision",
                                      cell: item => item[PROCESS_KEYS.SCHEMA_KEYS.precision] || "-",
                                      isRowHeader: true
                                    },
                                    {
                                      id: "comparison_value",
                                      header: "Equal to value",
                                      cell: item => item[PROCESS_KEYS.SCHEMA_KEYS.comparison_value] || "-",
                                      isRowHeader: true
                                    },
                                    {
                                      id: "non_empty_column",
                                      header: "Non-empty column",
                                      cell: item => item[PROCESS_KEYS.SCHEMA_KEYS.non_empty_column] === true ? "true" : "false",
                                      isRowHeader: true
                                    },
                                    {
                                      id: "last_updated_time",
                                      header: "Last updated time",
                                      cell: item => item[PROCESS_KEYS.SCHEMA_KEYS.last_updated_time_stamp] ? convertEpochToPST(item[PROCESS_KEYS.SCHEMA_KEYS.last_updated_time_stamp]) : "-",
                                      isRowHeader: true
                                    }
                                  ]}
                                  items={getValue(PROCESS_KEYS.schema)}
                                  loadingText="Loading schema details"
                                  sortingDisabled
                                  empty={
                                    <Box
                                      margin={{ vertical: "xs" }}
                                      textAlign="center"
                                      color="inherit"
                                    >
                                      <SpaceBetween size="m">
                                        <b>No schema yet</b>
                                      </SpaceBetween>
                                    </Box>
                                  }
                                  variant='embedded'
                                /> : ''}
                              </div>

                            }

                          </ExpandableSection>

                        </div>

                        {
                          isEditMode && isNewProcess ?
                            <div>
                              <SpaceBetween size="m">
                                <Box variant="awsui-key-label">Or upload a sample file to generate the schema</Box>
                                <FileUpload
                                  onChange={({ detail }) => { setSampleFile(detail.value) }}
                                  value={sampleFile}
                                  i18nStrings={{
                                    uploadButtonText: e =>
                                      e ? "Choose files" : "Choose file",
                                    dropzoneText: e =>
                                      e
                                        ? "Drop files to generate"
                                        : "Drop file to generate",
                                    removeFileAriaLabel: e =>
                                      `Remove file ${e + 1}`,
                                    limitShowFewer: "Show fewer files",
                                    limitShowMore: "Show more files",
                                    errorIconAriaLabel: "Error"
                                  }}
                                  showFileLastModified
                                  showFileSize
                                  showFileThumbnail
                                  tokenLimit={1}
                                  accept={'.csv'}
                                  constraintText="upload a sample csv file"
                                />
                              </SpaceBetween>
                            </div> :
                            <></>
                        }

                      </ColumnLayout>

                      <Box>
                        {
                          processDataEdited[PROCESS_KEYS.action] === 'DELSERT' ?
                            <>
                              {(selectedDelsertKeys?.length >= 1 && processDataEdited[PROCESS_KEYS.team] && processDataEdited[PROCESS_KEYS.business]
                               && processDataEdited[PROCESS_KEYS.dataset_name]) ?
                                <SpaceBetween size="m">
                                  <Alert
                                    statusIconAriaLabel="Info"
                                    header="Selected DELSERT Keys"
                                  >
                                    <ul>
                                      {selectedDelsertKeys?.map((delsertKey) => (
                                        <li key={delsertKey}> {delsertKey}</li>
                                      ))}
                                    </ul>
                                  </Alert>
                                    <ExpandableSection headerText="View generated DELSERT script">
                                      <CodeView
                                        content={`${delsertDeleteScript.join('\n')} \n\n\n ${delsertInsertScript.join('\n')}\n`}
                                        highlight={rubyHighlight}
                                        lineNumbers
                                      />
                                    </ExpandableSection>
                                    { !isEditMode && canEdit && <Button variant="primary" onClick={() => setCleanupDataModalVisible(true)} >Cleanup</Button> }
                                </SpaceBetween> :
                                <Alert
                                  statusIconAriaLabel="Info"
                                  type="error"
                                >
                                  Team, Business, Dataset name, Schema and minimum of one DELSERT key is required for DELSERT operation.
                                </Alert>
                              }

                            </> :
                            <></>
                        }
                      </Box>
                    </SpaceBetween>
                  </>

                  : <></>}

                  <SpaceBetween direction="vertical" size="s">
                    {
                      isEditMode && id == appSettings[currentStage]?.appId ?
                      <CustomCheckbox field="QUEUED_EXECUTION" getValue={getValueCustomAttributes} updateValue={updateValueCustomAttributes} text="Queued execution" />
                        : ''
                    }
                    </SpaceBetween>

                  <Box>
                    <ColumnLayout columns={getValueCustomAttributes('NOTIFICATION_PREFERENCE') !== 'DISABLE_ALL' ? 2 : 1}>
                      <Box>{notificationConfigurationContent}</Box>
                      {getValueCustomAttributes('NOTIFICATION_PREFERENCE') !== 'DISABLE_ALL' && (
                        <Box>{emailConfigurationContent}</Box>
                      )}
                    </ColumnLayout>
                  </Box>
              </SpaceBetween>
              
            </Container>
          </SpaceBetween>
          <SpaceBetween size="m">
            <Box>
              {errorMessage && (
                <Box variant="p" color="text-status-error">
                  {errorMessage}
                </Box>
              )}
            </Box>
            {
              (isNewProcess && canAdd) ?
                <div className="buttons">
                  <SpaceBetween direction="horizontal" size="l">
                    <Button variant="primary" onClick={(processDataEdited.hasOwnProperty(PROCESS_KEYS.action) && processDataEdited[PROCESS_KEYS.action] === 'DELSERT') ? () => delsertPopup('add') : addProcessDetails}
                    disabled={!enableEditAction} >Save</Button>
                  </SpaceBetween>
                </div>
                :
                ''
            }
            {
              !isNewProcess && isEditMode ?
                <SpaceBetween direction="vertical" size="l">
                  <Textarea 
                  class="description"
                  onChange={({ detail }) => setUpdateComments(detail.value)}
                  value={updateComments}
                  placeholder="Comments"
                  ></Textarea>
                  <div className="buttons">
                  <SpaceBetween direction="horizontal" size="l">
                    <Button variant="primary" onClick={(processDataEdited.hasOwnProperty(PROCESS_KEYS.action) && processDataEdited[PROCESS_KEYS.action] === 'DELSERT') ? () => delsertPopup('update') : updateProcessDetails} disabled={!enableEditAction} >Update</Button>

                    <Button onClick={cancelEdition}>Cancel</Button>
                  </SpaceBetween>
                </div>
                </SpaceBetween>
                :
                ''
            }
          </SpaceBetween>

          <br />
          {
            !isNewProcess && !isEditMode ?
              <SpaceBetween size="l" >
                <Feedback appId={id} pageId={`frisco_process_${id}_${pid}`} userId={userId} parentId={"null"} level={0} limit={1}></Feedback>
              </SpaceBetween> : ''
          }
        </ContentLayout>}
        {isCleanupDataModalVisible && <CleanupDataModal 
            visible={isCleanupDataModalVisible}
            setVisible={setCleanupDataModalVisible}
            data={getValue(PROCESS_KEYS.schema).filter(col => col.delsert_key === true)}
            id={id}
            pid={pid}
            userId={userId}
          />
        }
        <Modal
      onDismiss={() => setDelsertSubmitPopupVisible(false)}
      visible={delsertSubmitPopupVisible}
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={() => {setDelsertSubmitPopupVisible(false)}}>Go Back</Button>
            <Button variant="primary" onClick={()=>{
              
              delsertPopupCalledFrom === 'add' ? addProcessDetails() : updateProcessDetails();
              setDelsertSubmitPopupVisible(false);}}>Save</Button>
          </SpaceBetween>
        </Box>
      }
      header="Please Review"
    >
      <Box>
      All unique values from the specified key(s) will be used to replace data from the file to the target table.
      </Box>
        <Alert
          statusIconAriaLabel="Info"
          header="Selected DELSERT Keys"
        >
          <ul>
            {selectedDelsertKeys?.map((delsertKey) => (
              <li key={delsertKey}> {delsertKey}</li>
            ))}
          </ul>
        </Alert>
    </Modal>
    </>
  )

  const helpContent = (
    <HelpPanel header={<Box variant="h2">Glossary</Box>}>
        <Box>
        <SpaceBetween direction="horizontal" size="s">
          {/* <Box variant="strong">2 touch approval</Box> */}
          {/* <Box>Check the box if the use case is 'Enable 2 touch approval' for the two touch approval workflow for SOX purposes or for other regulatory purposes (such as statutory disclosure generation or publicly published balances such as TTC).</Box> */}
          <h4>2 touch approval required if</h4>
          <ul>
            <li>a) Ledger Impact = Primary Ledger (US GAAP) OR Secondary Ledger (Local GAAP) OR Both Primary and Secondary Ledger (US GAAP/Local GAAP/IFRS) AND</li>
            <li>b) Financial Impact &gt; $500MM</li>
          </ul>
          <h4>2 touch approval NOT required if</h4>
          <ul>
            <li>a) Ledger Impact = Other regulations OR Operational AND</li>
            <li>b) Financial Impact &lt; $500MM</li>
          </ul>
        </SpaceBetween>
        </Box>
    </HelpPanel>
);


  return (
    <AppLayout
      disableContentPaddings={true}
      content={Content}
      navigation={<SideNav activeHref={`/App/${id}/process/${pid}`} id={id} pid={pid} process={processData} back={backUrl}/>}
      contentType="default"
      navigationOpen={NavOpen}
      navigationHide={props.disableAppLayout}
      onNavigationChange={() => {
        setNavOpen(!NavOpen);
      }}
      tools={helpContent}
      toolsOpen={toolsOpen}
      onToolsChange={() => { setToolsOpen(!toolsOpen) }}
      headerVariant={props.disableAppLayout ? undefined:"high-contrast"}
    />
  );
};
